import { apiHost, backStageHost, backStageTowerHost } from '@/env'
export default {
  // 灰度
  API_GRAY: `${apiHost}/school/gray/listSchoolBizGray`,
  API_GRAY_BY_ORG_ID: `${apiHost}/school/gray/listSchoolBizGrayByOrgId`,
  // 根据设备第三方id获取设备id
  API_GET_DEVICE_BY_TPID: `${apiHost}/device/getDeviceByTpId`,
  // 请假列表(今日)
  API_LEAVE_LIST_TODAY: `${apiHost}/leave/getTodayLeaveList`,
  // 请假记录
  API_LEAVE_RECORDS: `${apiHost}/leave/getHistoryLeaveRecordList`,
  // 发起请假(代)
  API_LEAVE_APPLY: `${apiHost}/leave/leaveApplication`,
  // 同意请假
  API_LEAVE_AGREE: `${apiHost}/leave/agreeLeave`,
  // 拒绝请假
  API_LEAVE_REJECT: `${apiHost}/leave/rejectLeave`,
  // 撤销请假申请
  API_LEAVE_CANCEL: `${apiHost}/leave/cancleLeaveApplication`,
  // 同意撤销请假申请
  API_LEAVE_CANCEL_AGREE: `${apiHost}/leave/agreeCancleLeave`,
  // 拒绝撤销请假申请
  API_LEAVE_CANCEL_REJECT: `${apiHost}/leave/rejectCancleLeave`,
  // 统计待审核请假数量
  API_LEAVE_AGENT_APPLY_COUNT: `${apiHost}/leave/countWaitingApproveLeave`,
  // 学生请假记录导出
  API_LEAVE_EXPORT_RECORD: `${apiHost}/school/export/exportLeaveRecordExcel`,
  // 学生请假记录导出进度查询
  API_LEAVE_EXPORT_PROGRESS: `${apiHost}/school/export/getTaskInfo`,
  // 保存/编辑设备考勤禁用时段
  API_LEAVE_AGENT_COUNT_FORBITTIME_SAVE_EDIT: `${apiHost}/school/attendance/saveDeviceNoAttendanceTime`,
  // 查询学生的标签和性别
  API_GET_LEAVE_STUDENT_TAG_AND_SEX: `${apiHost}/leave/getLeaveStudentTagAndSex`,
  // 查询请假时间冲突的学生请假记录列表
  API_GET_CONFLICT_LEAVE_LIST: `${apiHost}/leave/getConflictLeaveList`,
  // 查询请假通行权限
  API_GET_LEAVE_PERMIT_DEVICES: `${apiHost}/school/config/getLeavePermitDevices`,
  // 编辑请假通行权限
  API_UPDATE_LEAVE_PERMIT_DEVICES: `${apiHost}/school/config/updateLeavePermitDevices`,
  // 学生请假通行设备
  API_UPDATE_LEAVE_PERMIT_DEVICES_V2: `${apiHost}/school/config/updateLeavePermitDevicesV2`,
  // 查询家长请假可申请时间
  API_GET_ALLOW_GUARDIAN_LEAVE_WEEKDAYS: `${apiHost}/school/config/getAllowGuardianLeaveWeekdays`,
  // 编辑家长请假可申请时间
  API_UPDATE_ALLOW_GUARDIAN_LEAVE_WEEKDAYS: `${apiHost}/school/config/updateAllowGuardianLeaveWeekDays`,
  // 查询允许请假时段
  API_GET_ALLOW_LEAVE_TIME_PERIOD: `${apiHost}/school/config/getAllowLeaveTimePeriod`,
  // 编辑请假允许时段
  API_UPDATE_ALLOW_LEAVE_TIME_PERIOD: `${apiHost}/school/config/updateAllowLeaveTimePeriod`,
  // 查询请假返校证明设置
  API_LEAVE_BACK_CONFIG_GET: `${apiHost}/school/h5/leaveBack/config/get`,
  // 保存请假返校证明设置
  API_LEAVE_BACK_CONFIG_SAVE: `${apiHost}/school/h5/leaveBack/config/save`,
  // 查询请假返校证明详情
  API_LEAVE_BACK_GET_DETAIL: `${apiHost}/school/h5/leaveBack/getDetail`,
  // 给家长发送提醒上传请假返校证明通知
  API_LEAVE_BACK_NOTICE_GUARDIAN: `${apiHost}/school/h5/leaveBack/noticeGuardian`,
  // 提交/重新提交请假返校证明
  API_LEAVE_BACK_SUBMIT: `${apiHost}/school/h5/leaveBack/submit`,
  // 修改请假返校证明状态
  API_LEAVE_BACK_UPDATE_STATUS: `${apiHost}/school/h5/leaveBack/updateStatus`,
  // 请假日统计
  API_LEAVE_GET_DAY_STAT: `${apiHost}/leave/getLeaveDayStat`,
  // 请假日统计详情
  API_LEAVE_GET_DAY_STAT_DETAIL: `${apiHost}/leave/getLeaveDayStatDetail`,
  // 查询请假类型
  API_LEAVE_GET_TYPE_GROUP: `${apiHost}/leave/getLeaveTypeGroup`,
  // 保存自定义请假类型
  API_LEAVE_SAVE_CUSTOM_TYPE: `${apiHost}/leave/saveCustomLeaveType`,
  // 删除保存自定义请假类型
  API_LEAVE_DELETE_CUSTOM_TYPE: `${apiHost}/leave/deleteCustomLeaveType`,
  // 根据模块查询灰度机构列表
  API_LEAVE_BATCH_ORGIDS: `${apiHost}/school/gray/listBatchLeaveOrgId`,
  // 批量请假
  API_LEAVE_BATCH: `${apiHost}/leave/batchLeave`,
  // 查询批量请假任务结果
  API_LEAVE_BATCH_TASK: `${apiHost}/leave/getBatchLeaveTaskResult`,
  // 获取请假自定义表单
  API_GET_CUSTOM_LEAVE_FORM: `${apiHost}/leave/getLeaveAuditForm`,
  // 获取请假子类型
  API_GET_SUB_LEAVE_TYPE_LIST: `${apiHost}/leave/querySubLeaveTypeList`,
  // 更新请假子类型
  API_UPDATE_SUB_LEAVE_TYPE: `${apiHost}/leave/forceUpdateSubLeaveType`,
  // 获取请假升级状态
  API_GET_LEAVE_UPDATE_STATE: `${apiHost}/leave/getLeaveUpgradeSwitch`,
  // 设置请假升级状态
  API_SET_LEAVE_UPDATE_STATE: `${apiHost}/leave/saveLeaveUpgradeSwitch`,
  // 查询自动销假开关状态
  API_GET_LEAVE_REVOKE_STATE: `${apiHost}/leave/getAutoCheckoutLeaveSwitch`,
  // 设置自动销假开关状态
  API_SET_LEAVE_REVOKE_STATE: `${apiHost}/leave/saveAutoCheckoutLeaveSwitch`,
  // 主动销假
  API_CHECK_OUT_LEAVE: `${apiHost}/leave/checkoutLeave`,
  // 获取家长签到开关信息
  API_LEAVE_GET_PARENT_SWITCH: `${apiHost}/leave/getLeaveParentSwitch`,
  // 设置家长签到开关
  API_LEAVE_SET_PARENT_SWITCH: `${apiHost}/leave/setLeaveParentSwitch`,
  // 设置家长刷脸签到的设备列表
  API_LEAVE_SET_DEVICE_LIST: `${apiHost}/leave/setLeaveParentDeviceList`,
  // 查询年级-班级树结构
  API_GET_GRADE_TREE: `${apiHost}/school/getGradeTree`,
  /* ---------------- 通知 ---------------- */
  // 查询通知组列表
  API_GET_NOTICE_GROUPS: `${apiHost}/school/notice/getNoticeGroups`,
  // 获取通知组详情
  API_NOTICE_GROUP_DETAIL: `${apiHost}/school/notice/getNoticeGroup`,
  // 保存通知组
  API_SAVE_NOTICE_GROUP: `${apiHost}/school/notice/saveNoticeGroup`,
  // 编辑通知组
  API_UPDATE_NOTICE_GROUP: `${apiHost}/school/notice/updateNoticeGroup`,
  // 删除通知组
  API_DELETE_NOTICE_GROUP: `${apiHost}/school/notice/deleteNoticeGroup`,
  /* ---------------- 通知 ---------------- */
  // 查询请假详情
  API_GET_LEAVE_DETAIL: `${apiHost}/leave/getLeaveDetail`,
  // 撤销请假
  API_CANCEL_LEAVE: `${apiHost}/leave/cancelLeave`,
  // 修改请假
  API_UPDATE_LEAVE: `${apiHost}/leave/updateLeave`,
  // 请假
  API_LEAVE_APPLICATION: `${apiHost}/leave/leaveApplication`,
  // 查询请假单位
  API_LEAVE_GET_DURATION_UNIT: `${apiHost}/school/config/getLeaveDurationUnit`,
  // 编辑请假单位
  API_LEAVE_UPDATE_DURATION_UNIT: `${apiHost}/school/config/updateLeaveDurationUnit`,
  // 计算请假时长
  API_CALCULDATE_LEAVE_DURATION: `${apiHost}/leave/calculateLeaveDuration`,
  // 查询请假时长明细
  API_GET_LEAVE_DURATION_DETAIL: `${apiHost}/leave/getLeaveDurationDetail`,
  // 查询请假通行权限
  API_GET_LEAVE_PERMISION_DEVICES: `${apiHost}/leave/getStudentLeavePermitDevices`,
  // 查询是否允许学生发起请假
  API_GET_LEAVE_ALLOW: `${apiHost}/school/config/getAllowStudentSubmitLeave`,
  // 编辑允许学生发起请假
  API_SET_LEAVE_ALLOW: `${apiHost}/school/config/updateAllowStudentSubmitLeave`,
  // 第三方授权协议
  API_ORG_AUTH_APPLY_LIST: `${apiHost}/school/authorize/getAppOrgAuthApplyList`,
  // 查询请假外出通行模板详情
  API_AUDIT_TEMPLATE_ABSENCE: `${apiHost}/attence/audit/template/absence`,
  // 请假外出通行开关切换
  API_AUDIT_TEMPLATE_ABSENCE_STATUS_TOGGLE: `${apiHost}/attence/audit/template/absence/status/toggle`,
  // 查询机构可管理的所有审批表单(钉钉OA)
  API_GET_APPROVAL_FORM_LIST: `${apiHost}/attence/audit/template/absence/forms`,
  // 请假外出通行模板绑定表单及设备
  API_AUDIT_TEMPLATE_ABSENCE_BIND: `${apiHost}/attence/audit/template/absence/bind`,
  // 职工请假通行列表
  API_AUDIT_GET_DEVICE_LIST: `${apiHost}/school/config/getStaffPaDeviceList`,
  // 查询设备是否需要升级
  API_FAMILYCALL_IS_UPGRADE: `${apiHost}/squirrel/h5/familyCall/isUpgrade`,
  // 考勤
  // 人脸录入统计
  API_ATTENDANCE_FACE_COUNT: `${apiHost}/attendance/getMount`,
  // 人脸已录入人脸列表
  API_ATTENDANCE_FACE_LIST: `${apiHost}/attendance/getRecordFace`,
  // 获取所有考勤记录统计
  API_ATTENDANCE_STATUS_ALL: `${apiHost}/school/attendance/getCampusStat`,
  // 批量查询班级考勤统计
  API_ATTENDANCE_STATUS_BY_CLASS: `${apiHost}/attendance/getDeptStat`,
  // 条件搜索学生考勤状态
  API_ATTENDANCE_STATUS_FOR_STUDENTS: `${apiHost}/attendance/getUserAttendanceStat`,
  // 获取学生考勤流水
  API_ATTENDANCE_RECORDS_FOR_STUDENT: `${apiHost}/attendance/getAttendanceRecords`,
  // 获取所有考勤组
  API_ATTENDANCE_GROUP: `${apiHost}/attendance/getAttendanceGroups`,
  // 查询考情人员
  API_ATTENDANCE_RANGE: `${apiHost}/group/range`,
  // 学生考勤日历
  API_LEAVE_AGENT_COUNT_CALENDAR: `${apiHost}/school/attendance/getAttendanceCalendar`,
  // 学生某日考勤记录
  API_LEAVE_AGENT_COUNT_DAYRECORD: `${apiHost}/school/attendance/queryUserAttendanceRecords`,
  // 学生月考勤记录
  API_LEAVE_AGENT_COUNT_STUDENTMONTHRECORD: `${apiHost}/school/attendance/getStudentMonthStat`,
  // 条件搜索学生考勤状态
  API_LEAVE_AGENT_COUNT_SEARCHSTATUS: `${apiHost}/school/attendance/getUserDayAttendanceStat`,
  // 条件搜索学生考勤状态 - new
  API_LEAVE_AGENT_COUNT_SEARCHSTATUS_NEW: `${apiHost}/school/attendance/getUserDayAttendanceStatNew`,
  // 安部门或者班级搜索
  API_LEAVE_AGENT_COUNT_SEARCHCLASS: `${apiHost}/school/attendance/getDeptStat`,
  // 查询考勤组列表
  API_LEAVE_AGENT_COUNT_SEARCHATTENDANCE: `${apiHost}/school/attendance/getAttendanceGroupList`,
  // 查询考勤禁用时段
  API_ATTENDANCE_SEARCH_FORBIT_TIME: `${apiHost}/school/attendance/getDeviceNoAttendanceTimes`,
  // 查机构所有设备的考勤禁用时段
  API_ATTENDANCE_SEARCH_ALL_FORBIT_TIME: `${apiHost}/school/attendance/getDeviceListWithAttendanceTimes`,
  // 查询考勤组详情
  API_ATTENDANCE_SEARCH_GROUP_DETAIL: `${apiHost}/school/attendance/getAttendanceGroup`,
  // 查询所有已经存在成员组的部门和人员钉钉id
  API_ATTENDANCE_SEARCH_CANNOTSELECTED: `${apiHost}/school/notice/getPresenceMembers`,
  // 保存考勤组
  API_ATTENDANCE_SAVE_GROUP: `${apiHost}/school/attendance/saveAttendanceGroups`,
  // 编辑考勤组
  API_ATTENDANCE_EDIT_GROU: `${apiHost}/school/attendance/updateAttendanceGroup`,
  // 删除考勤组
  API_ATTENDANCE_DELETE_GROU: `${apiHost}/school/attendance/deleteAttendanceGroup`,
  // 修改学生考勤记录
  API_ATTENDANCE_MODIFY_RECORD: `${apiHost}/school/attendance/modifyAttendanceRecord`,
  // 搜索迟到早退未打卡
  API_ATTENDANCE_DAILY_STATUS: `${apiHost}/school/attendance/getUserLLLDailyStates`,
  // 历史请假简单信息/leave/getSampleLeave
  API_ATTENDANCE_LEAVE_DETAIL: `${apiHost}/leave/getSampleLeave`,
  // 查询考勤时间配置
  API_ATTENDANCE_TIME: `${apiHost}/school/attendance/getTimeSettings`,
  // 新增/编辑考勤时间配置
  API_ATTENDANCE_SAVE_EDITE_TIME: `${apiHost}/school/attendance/saveTimeSetting`,
  // 删除考勤时间配置
  API_ATTENDANCE_DELETE_TIME_SETTING: `${apiHost}/school/attendance/deleteTimeSetting`,
  // 查询单个考勤时间是否被使用
  API_ATTENDANCE_SEARCH_IS_USE: `${apiHost}/school/attendance/getTimeSetting`,
  // 查询学生的考勤组日期为星期几,进行置灰处理 /school/attendance/getMemberCalendar
  API_ATTENDANCE_GREY_DEAL: `${apiHost}/school/attendance/getMemberCalendar`,
  // 考勤报表导出
  API_ATTENDANCE_EXPORT_EXCEL: `${apiHost}/school/export/exportAttendanceExcel`,
  // 搜索学生信息
  API_ATTENDANCE_SEARCH: `${apiHost}/school/student/searchByName`,

  // 查询所有部门月统计 /school/attendance/getCampusMonthStat
  API_ATTENDANCE_ALL_RECORD: `${apiHost}/school/attendance/getCampusMonthStat`,
  // 查询机构下的校区部门出勤人数月统计
  API_ATTENDANCE_MONTH_RECORD: `${apiHost}/school/attendance/getCheckMonthStat`,
  // 部门月统计
  API_ATTENDANCE_PARTMENT_RECORD: `${apiHost}/school/attendance/getDeptMonthStat`,
  // 自定义角色部门月统计
  API_ATTENDANCE_CUSTOM_ROLE_PARTMENT_RECORD: `${apiHost}/school/attendance/customRole/getDeptMonthStat`,
  // 部门月统计请假，缺勤，未打卡查询
  API_ATTENDANCE_PARTMENT_DETAILL: `${apiHost}/school/attendance/getDeptLLLDailyStates`,
  // 部门月统计请假，缺勤，未打卡查询 -new
  API_ATTENDANCE_PARTMENT_DETAILL_NEW: `${apiHost}/school/attendance/getDeptLLLDailyStatesNew`,
  // 考勤成员校验接口
  API_ATTENDANCE_CHECHET: `${apiHost}/school/attendance/checkMember`,
  // 班主任查询班级下的学生
  API_ATTENDANCE_HEARD_MASTER: `${apiHost}/school/attendance/searchSchoolStudentBaseInfo`,
  // 判断该用户是否是首次登入
  API_ISFIRST_LOGIN: `${apiHost}/school/attendance/isFirstLogin`,
  /* new attendance */
  // 搜索学生上下学的考勤状态详情数据
  API_ATTENDANCE_USER_DAY_STATE_IN_OUT_TYPE: `${apiHost}/school/attendance/getUserDayAttendanceStatInOutType`,
  // 查询校区日统计
  API_ATTENDANCE_CAMPUS_STATE_IN_OUT_TYPE: `${apiHost}/school/attendance/getCampusStatInOutType`,
  // 查询班级日统计
  API_ATTENDANCE_DEPT_STATE_IN_OUT_TYPE: `${apiHost}/school/attendance/getDeptStatInOutType`,
  // 查询某个机构的某个业务是否灰度
  API_CAMPUS_BIZ_GRAY: `${apiHost}'/school/gray/getSchoolBizGray`,
  // 查询校区/部门的月出勤信息
  API_ATTENDANCE_CHECK_MONTH_STATE_NEW: `${apiHost}/school/attendance/getCheckMonthStatNew`,
  // 查询某日所有的打卡时间
  API_ATTENDANCE_LIST_CHECK_TIMEs: `${apiHost}/school/attendance/listAttendanceCheckTime`,
  // 查询年级日统计
  API_ATTENDANCE_GET_GRADE_STATE_IN_OUT_TYPE: `${apiHost}/school/attendance/getGradeStatInOutType`,
  // 考勤组预览
  API_ATTENDANCE_GROUP_OVERVIEW: `${apiHost}/school/attendance/group/overview`,
  // 查询存在未参与学生的班级列表
  API_NO_ATTENDANCE_CLASS_LIST: `${apiHost}/school/group/getExistNoAttendanceStudentClassList`,
  // 未参于考勤学生列表
  API_ATTENDANCE_GROUP_GET_NO_STUDENT_LIST: `${apiHost}/school/group/getNoAttendanceStudentList`,
  // 学生加入考勤组
  API_ATTENDANCE_GROUP_ADD_STUDENT: `${apiHost}/school/group/addGroupStudent`,
  // 查学生详情
  API_ATTENDANCE_GROUP_GET_STUDENT_INFO: `${apiHost}/school/student/getStudentInfo`,
  // 查学生考勤组
  API_ATTENDANCE_GROUP_GET_BY_STUDENT_ID: `${apiHost}/school/group/getByStudentId`,
  // 获取标签统计
  API_SANDBOX_GET_TAG_STATISTICS: `${apiHost}/school/sandbox/groupTree/getAccommodationTagStatistics`,
  // 准备部门树
  API_SANDBOX_PREPARE: `${apiHost}/school/sandbox/groupTree/prepare`,
  // 创建选人组件沙盒
  API_SANDBOX_CREATE: `${apiHost}/school/sandbox/groupTree/create`,
  // 获取沙盒状态
  API_SANDBOX_GET_STSTUS: `${apiHost}/school/sandbox/groupTree/getStatus`,
  // 查树节点信息
  API_SANDBOX_GET_NODES: `${apiHost}/school/sandbox/groupTree/getSubNodes`,
  // 加部门筛选条件
  API_SANDBOX_SELECT_GROUPS: `${apiHost}/school/sandbox/groupTree/selectNodes`,
  // 移除部门筛选条件
  API_SANDBOX_UNSELECT_GROUPS: `${apiHost}/school/sandbox/groupTree/unselectNodes`,
  // 加已选学生
  API_SANDBOX_SELECT_STUDENTS: `${apiHost}/school/sandbox/groupTree/selectStudents`,
  // 移除已选学生
  API_SANDBOX_SELECT_UNSTUDENTS: `${apiHost}/school/sandbox/groupTree/unselectStudents`,
  // 清除所有已选择
  API_SANDBOX_CLEAR_ALL: `${apiHost}/school/sandbox/groupTree/unselectAll`,
  // 查询已选学生列表-有选项的班级列表
  API_SANDBOX_GET_CHECKED_CLASSES: `${apiHost}/school/sandbox/groupTree/getCheckedClasses`,
  // 查询已选学生列表-学生列表
  API_SANDBOX_GET_CHECKED_STUDENTS: `${apiHost}/school/sandbox/groupTree/getCheckedStudents`,
  // 查询学生考勤周历
  API_ATTENDANCE_GET_WEEK_CALENDAR: `${apiHost}/school/attendance/getAttendanceWeekCalendar`,
  /* new attendance */

  /* New interface for attendance statistics */
  // 查询某天可用的考勤组
  API_GET_AVAILABLE_BY_DIMDAY: `${apiHost}/school/attendance/group/getAvailableByDimDay`,
  // 查询某天可用的考勤组以及考勤时段
  API_GET_GROUP_AND_TIME_PERIOD_BY_DIMDAY: `${apiHost}/school/attendance/group/getGroupAndTimePeriodByDimDay`,
  // 查询某个考勤组下的时段配置
  API_GET_GROUP_AND_TIME_PERIOD_BY_GROUPID: `${apiHost}/school/attendance/group/getTimePeriodByGroupId`,
  // 获取校区以及所有班级的上下学统计新接口
  API_POST_DEPT_STATISTICS: `${apiHost}/school/attendance/getDeptStatistics`,
  // 班主任修改考勤结果权限查询
  API_GET_ALLOW_MODIFY_ATTENDANCE: `${apiHost}/school/config/getAllowModifyAttendanceResult`,
  // 班主任修改考勤结果权限设置
  API_UPDATE_ALLOW_MODIFY_ATTENDANCE: `${apiHost}/school/config/updateAllowModifyAttendanceResult`,
  /* New interface for attendance statistics */

  // dingHost
  // 钉钉授权 免登
  API_DING_TOKEN: `${apiHost}/ding/getJsAuth`,
  // 获取免登用户信息
  API_DING_USER_INFO: `${apiHost}/ding/corpUser/getLoginUserInfo`,
  // 获取免登用户信息
  API_USER_INFO: `${apiHost}/school/corpUser/getLoginUserInfo`,
  // 移动浙学码用户信息
  API_LEARN_CODE_USER_INFO: `${apiHost}/school/learnCode/getLoginUserInfo`,
  // 移动浙学码cubeUserId-dingUserId
  API_LEARN_CODE_USER_MAPPING: `${apiHost}/school/cube/mapping`,
  // 删除机构成员人员数据
  API_DING_USER_REMOVW_FACE: `${apiHost}/ding/corpUser/removeUserFace`,
  // 查询人员详情
  API_DING_MEMBER_INFO: `${apiHost}/member/info`,
  // 同步通讯录
  API_DING_START_USER_SYNC: `${apiHost}/ding/corp/startUserSync`,
  // 同步通讯录状态
  API_DING__SYNC_STATUS: `${apiHost}/ding/corp/getUserSynStatus`,
  // 查询家校同步状态
  API_SCHOOL_SYNC_STATUS: `${apiHost}/school/corpUser/getSchoolSynStatus`,
  // 钉钉Id转化为部门Id
  API_DING_TRANSFORM_DEPT: `${apiHost}/dept/getTpIdDeptIdRelation`,
  // 部门Id转化未钉钉Id
  API_DING_TRANSFORM_TPDEPT: `${apiHost}/dept/getDeptIdTpIdRelation`,
  // 魔点人员id转钉人员id
  API_MEMBERID_TPIDRELATION: `${apiHost}/member/getMemberIdTpIdRelation`,
  // 钉人员id转魔点人员id
  API_TPIDME_MBERIDRELATION: `${apiHost}/member/getTpIdMemberIdRelation`,
  // 查询学生基本信息
  API_DING_STUDENT_BASE_INFO: `${apiHost}/ding/corp/school/getStudentBaseInfo`,
  // 查询学生信息
  API_DING_STUDENT_INFO: `${apiHost}/ding/corp/school/getStudentDetail`,
  // 查询老师信息
  API_DING_TEACHER_INFO: `${apiHost}/ding/corp/school/getTeacherList`,
  // 查询校区信息(旧列表)
  API_DING_CAPMUS_LIST: `${apiHost}/ding/corp/school/getCapmusList`,
  // 查询校区信息(新列表)
  API_DING_CAPMUS_LIST_NEW: `${apiHost}/ding/corp/school/getNewCapmusList`,
  // 查询学段信息(列表)
  API_DING_PERIOD_LIST: `${apiHost}/ding/corp/school/getPeriodList`,
  // 获取班级详情
  API_DING_SCHOOL_CLASS_DETAIL: `${apiHost}/ding/corp/school/getSchoolClassDetail`,
  // 查询年级信息(列表)
  API_DING_GRADE_LIST: `${apiHost}/ding/corp/school/getGradeList`,
  // 查询班级信息(列表)(分页)
  API_DING_CLASS_LIST: `${apiHost}/ding/corp/school/getPaginationClassList`,
  // 查询学生信息(列表)(分页)
  API_DING_STUDENT_LIST: `${apiHost}/ding/corp/school/getPaginationStudentList`,
  // 学生按名字搜索-分校区(分页)
  API_DING_SEATRCH_STUDENT_LIST: `${apiHost}/ding/corp/school/searchStudentList`,
  // 检查zjCube机构是否初始化
  API_DING_ZJCUBE_CHECK_INIT: `${apiHost}/school/corpUser/zjCube/checkInit`,
  // 获取zjCube信息
  API_DING_ZJCUBE_INFO: `${apiHost}/school/corpUser/zjCube/info`,
  // 是否魔方应用
  API_CUBE_JUDGE_ORG_IS_CUBE: `${apiHost}/zjcube/org/judgeOrgIsCube`,
  API_ORG_INFO: `${apiHost}/org/info`,
  API_CAMPUS_ORG_INFO: `${apiHost}/fishnetweb/campus/org/info`,
  // fishnetHost
  // 上传临时图片
  API_FISHNET_UPLOAD_TEMP_PIC_BY_BINARY: `${apiHost}/common/uploadTempPicByBinary`,
  // 查询部门详情
  API_FISHNET_GET_DEPT_INFO: `${apiHost}/dept/deptInfo`,
  API_FISHNET_GET_SUB_DEPTS: `${apiHost}/dept/depts`,
  API_FISHNET_INFO_BY_IDS: `${apiHost}/member/simpleInfoByIds`,
  API_FISHNET_DEPTS_BY_IDS: `${apiHost}/dept/deptInfoByIds`,
  API_FISHNET_GET_DEPT_MEMBERS: `${apiHost}/dept/members`,
  // 获取成员基本信息(不含部门)
  API_FISHNET_GET_MEMBER_INFO: `${apiHost}/member/simpleInfoByTpId`,
  // 查询成员
  API_FISHNET_GET_MEMBERS_BY_KEY: `${apiHost}/member/list`,
  // DEBUG接口
  API_FISHNET_DEBUG: `${apiHost}/common/debug`,
  // 通过tpId获取成员标签
  API_FISHNET_GET_TPID_TAGS: `${apiHost}/tag/getMemberTagsByTpIds`,
  // 筛选人员
  API_SEARCH_MEMBERS: `${apiHost}/member/findMembersInDepts`,
  // 初始化标签
  API_SCHOOL_GET_TAGS: `${apiHost}/school/tag/getTags`,
  // 使用模板配置接口
  API_SCHOOL_GET_ATTENDANCE_BY_GROUP: `${apiHost}/school/attendance/getAttendanceGroupByTemplate`,
  // 设备配置/无禁用考勤时段个数
  API_SCHOOL_GET_DEVICE_DEPLOY_COUNT: `${apiHost}/school/attendance/getDeviceDeployCount`,
  // 考勤配置不完全个数接口
  API_SCHOOL_GET_ATTENDANCE_DEPLOY_COUNT: `${apiHost}/school/attendance/getAttendanceDeployCount`,
  // 考勤学生统计（校区总人数、参与考勤人数、未参与考勤人数）
  API_SCHOOL_GET_ATTENDANCE__STUDENT_DEPLOY_COUNT: `${apiHost}/school/attendance/getAttendanceStudentCount`,
  // 权限组学生统计（校区总人数、有权限的学生人数、无权限的学生人数）
  API_SCHOOL_GET_DOOR__STUDENT_DEPLOY_COUNT: `${apiHost}/school/attendance/getDoorStudentCount`,
  // 是否设置了审批流程
  API_LEAVE_EXIST_APPROVAL_PROCESS: `${apiHost}/leave/existApprovalProcess`,

  // 宿管
  // 查询宿管跨天
  API_GET_CROSS_HOUR: `${apiHost}/school/dorm/getDormTransSkyConfig`,
  // 查询机构宿舍日统计
  API_GET_DORM_DATA: `${apiHost}/school/dorm/getCampusStat`,
  // 查询机构宿舍日详情
  API_GET_DORM_DETAIL: `${apiHost}/school/dorm/getCampusDayDormDetail`,
  // 判断是否是宿舍管理员
  API_GET_ISDORM_ADMIN: `${apiHost}/school/dorm/judgeDormAdminByUserId`,
  /* 第三方ISV接口授权接口文档 */
  // 查询机构下申请授权信息列表
  API_GET_ORG_AUTH_APPLY_LIST: `${apiHost}/school/authorize/getAppOrgAuthApplyList`,
  // 审核接口
  API_AUTHORIZE_AUDIT: `${apiHost}/school/authorize/audit`,
  // 修改宿舍考勤结果
  API_MODIFY_DORM_ATTENDACE_RESULT: `${apiHost}/school/dorm/modifySignRecord`,
  // 新增宿管考勤组
  API_SAVE_DORM_GROUP: `${apiHost}/school/dorm/saveDormGroup`,
  // 编辑管考勤组
  API_UPDATE_DORM_GROUP: `${apiHost}/school/dorm/updateDormGroup`,
  // 查询单个宿管考勤组
  API_GET_DORM_GROUP: `${apiHost}/school/dorm/getDormGroup`,
  // 查询全部宿管考勤组
  API_GET_DORM_GROUP_LIST: `${apiHost}/school/dorm/listDormGroup`,
  // 删除宿管考勤组
  API_DELETE_DORM_GROUP: `${apiHost}/school/dorm/deleteDormGroup`,
  // 查询机构校区今日的宿管考勤统计(按照考勤组和时段或者班级统计)
  API_GET_DORM_REPORT: `${apiHost}/school/dorm/getDormGroupReport`,
  // 查询机构校区今日的宿管考勤统计明细
  API_GET_DORM_REPORT_DETAIL: `${apiHost}/school/dorm/getDormGroupReportDetail`,
  // 查询某个学生的宿管考勤打卡记录
  API_GET_USER_DORM_REPORT: `${apiHost}/school/dorm/getDormDingUserRecords`,
  // 查询某个学生的考勤日历
  API_GET_USER_DORM_CALENDAR: `${apiHost}/school/dorm/getDormCalendar`,
  // 查询宿管考勤组的多个时间配置
  API_GET_GROUP_PERIOD: `${apiHost}/school/dorm/listDormGroupTimePeriodId`,
  // 查询某个学生的考勤日历
  API_GET_DORM_WEEK_CALENDAR: `${apiHost}/school/dorm/getDormWeekCalendar`,
  // 导出宿管报表
  API_EXPORT_DORM_DATA: `${apiHost}/school/export/exportDormSignExcel`,
  // 宿舍模式获取考勤时段
  API_GET_LIST_DORM_GROUP: `${apiHost}/school/dorm/listDormGroupByOrgId`,
  // 获取校区下的宿舍树
  API_GET_DORM_TREE: `${apiHost}/squirrel/h5/dorm/getDormTree`,
  // 宿舍模式绑定宿舍和考勤组
  API_DEVICE_DORM_MODE_BIND: `${apiHost}/squirrel/h5/device/dormMode/bind`,
  // 测温统计
  //  查询校区体温统计
  API_TEMPERATURE_GET_CAMPUS_STAT: `${apiHost}/school/temperature/getCampusStat`,
  //  查询校区(班主任)班级体温统计
  API_TEMPERATURE_GET_DEOT_STAT: `${apiHost}/school/temperature/getDeptStat`,
  //  查询正常(异常,未测量)体温统计学生明细
  API_TEMPERATURE_GET_DETAIL: `${apiHost}/school/temperature/getTemperatureDetail`,
  //  获取体温范围
  API_TEMPERATURE_GET_RANGE: `${apiHost}/school/temperature/getTemperatureRange`,
  //  查询某个学生测温日历
  API_TEMPERATURE_GET_USER_RECORDS: `${apiHost}/school/temperature/queryUserTemperatureRecords`,
  //  查询学生温度月历
  API_TEMPERATURE_GET_CALENDAR: `${apiHost}/school/temperature/getUserTemperatureCalendar`,
  //  体温学生数据报表导出
  API_TEMPERATURE_EXPORT_EXCEL: `${apiHost}/school/export/exportTemperatureExcel`,
  //  查询学生信息
  API_TEMPERATURE_GET_USERINFO: `${apiHost}/school/temperature/getUserInfo`,
  //  保存人工复合记录
  API_TEMPERATURE_SAVE_INDICATOR: `${apiHost}/school/temperature/saveIndicator`,
  //  查询所有班级体温统计
  API_TEMPERATURE_CAMPUS_CLASS_STAT: `${apiHost}/school/temperature/getCampusAndAllClassStat`,
  // 数据大屏
  // 是否开通校园大屏
  API_JUDGE_OPEN_SCREEN: `${apiHost}/peacock/judgeOpenScreen`,
  // 查询机构投屏列表
  API_GET_SCREEN_LIST_BY_ORG_ID: `${apiHost}/peacock/getScreenListByOrgId`,
  // 生成uid
  API_GENERATE_UID: `${apiHost}/peacock/generateUid`,
  // 投屏断开连接
  API_DISCONNECT_SCREEN: `${apiHost}/peacock/disconnectScreen`,
  // 扫码登陆
  API_SCAN_LOGIN: `${apiHost}/peacock/scanLogin`,
  // 通过uid查询token
  API_GET_UID_BY_TOKEN: `${apiHost}/peacock/getUidByToken`,
  // 大屏列表
  API_LIST: `${apiHost}/peacock/view/list`,
  // 投屏更换视图
  API_SCREEN_CHANGE_VIEW: `${apiHost}/peacock/screenChangeView`,
  //  生成二维码
  API_GET_OR_CODE: `${apiHost}/peacock/genQrCode`,
  // 通过uid查询投屏id
  API_GET_SCREEN_ID_BY_UID: `${apiHost}/peacock/getScreenIdByUid`,
  // 通过uid查询投屏id
  API_GET_SCREEN_ID_BY_UID2: `${apiHost}/peacock/studentMeal/getScreenIdByUid`,
  // 根据班主任id查询班级投屏列表
  API_GET_SCREEN_LIST2: `${apiHost}/peacock/studentMeal/getScreenList`,
  // 扫码登陆
  API_SCAN_LOGIN2: `${apiHost}/peacock/studentMeal/scanLogin`,
  // 投屏断开连接
  API_SCREEN_DISCONNECT2: `${apiHost}/peacock/studentMeal/disconnectScreen`,
  // 获取机构视图限制数量
  API_SCREEN_LIMIT: `${apiHost}/peacock/getViewLimit`,

  //  班主任-学生列表api
  API_SCHOOL_FACE: `${apiHost}/school/face/getStudentFamilyFaceCount`,
  // 查询模块过期时间
  API_SCHOOL_MODULE_EXPIRE_DATE: `${apiHost}/school/module/getModuleExpireDate`,
  // 查询机构授权模块列表
  API_SCHOOL_MODULE_LIST: `${apiHost}/school/module/getModuleList`,
  // 查询机构最新套餐
  API_SCHOOL_ORG_SKU: `${apiHost}/school/module/getOrgSku`,
  // 查询免费试用模块
  API_GET_FREE_MODULE: `${apiHost}/school/module/getShowHintModules`,
  // 对Banner详情按钮是否有操作权限
  API_SCHOOL_COMMON_GIFT_STATUS: `${apiHost}/school/common/gift/getStatus`,
  // 为机构增加模块权限
  API_SCHOOL_ADD_MODULES: `${apiHost}/school/module/addModules`,
  // 弹性离校
  //  查询设置信息
  API_FLEXLEAVE_SETTING: `${apiHost}/school/flexleave/config/getOverView`,
  // 查询值班老师
  API_GET_SCHEDULED_TEACHERS: `${apiHost}/school/flexleave/config/getScheduleTeacher`,
  // 设置值周老师
  API_FLEXLEAVE_EDIT_TURNS: `${apiHost}/school/flexleave/config/saveScheduleTeacher`,
  // 查询学生刷脸设备
  API_GET_STUDENTS_DEVICE: `${apiHost}/school/flexleave/config/getStudentDevice`,
  //  设置学生刷脸设备
  API_SAVE_STUDENTS_SETTING: `${apiHost}/school/flexleave/config/saveStudentDevice`,
  // 查询老师刷脸设备
  API_GET_TEACHERS_DEVICE: `${apiHost}/school/flexleave/config/getGuardianDevice`,
  //  设置老师刷脸设备
  API_SAVE_TEACHERS_SETTING: `${apiHost}/school/flexleave/config/saveGuardianDevice`,
  // 查询托管配置启用时间
  API_GET_FLEXLEAVE_TIMEOPEN: `${apiHost}/school/flexleave/config/getFlexLeaveTime`,
  // 设置托管配置启用时间
  API_FLEXLEAVE_EDIT_TIMEOPEN: `${apiHost}/school/flexleave/config/saveFlexLeaveTime`,
  //  设置是否通知
  API_FLEXLEAVE_EDIT_NOTITY: `${apiHost}/school/flexleave/config/saveNotifyAdviserOnGuardianArrival `,
  //  允许家长提前刷脸
  API_FLEXLEAVE_GUARDIAN_SCAN_AHEAD: `${apiHost}/school/flexleave/config/saveAllowGuardianFaceScanAhead`,
  // 查询托管学生
  API_FLEXLEAVE_GET_STUDENTS: `${apiHost}/school/flexleave/biz/getStudentList`,
  // 学生滞留签到
  API_FLEXLEAVE_BIZ_CHECKIN: `${apiHost}/school/flexleave/biz/checkIn`,
  // 一键通知家长
  API_NOTIFY_PARENTS: `${apiHost}/school/flexleave/biz/notifyAllGuardian`,
  // 获取通知进度
  API_GET_NOTIFY_PROGRESS: `${apiHost}/school/school/getTaskProgress`,
  // 查询某人的高亮模块
  API_GET_HIGHLIGHT_MODULE_LIST: `${apiHost}/school/highLight/listModuleHighLight`,
  // 消除某人的高亮模块
  API_CLEAR_MODULE_HIGHLIGHT: `${apiHost}/school/highLight/clearModuleHighLight`,
  // 考勤组预览
  API_ATTENDANCE_OVERVIEW: `${apiHost}/school/group/getAttendanceStudentOverview`,
  // 提交预选项
  API_SANDBOX_COMMIT: `${apiHost}/school/sandbox/groupTree/commitPreSelections`,
  // 取消预选项
  API_SANDBOX_ROLLBACK: `${apiHost}/school/sandbox/groupTree/rollbackPreSelections`,

  // 获取进出校车辆自动考勤开关
  API_SCHOOL_GET_ATTENDANCE_CONFIG: `${apiHost}/school/config/getAttendanceConfig`,
  // 获取请假车场设备
  API_SCHOOL_GET_LEAVE_SUPPORT_CONFIG: `${apiHost}/school/config/getLeaveSupportConfig`,
  // 设置进出校车辆自动考勤开关
  API_SCHOOL_SET_ATTENDANCE_CONFIG: `${apiHost}/school/config/setAttendanceConfig`,
  // 设置请假车场设备
  API_SCHOOL_SET_LEAVE_SUPPORT_CONFIG: `${apiHost}/school/config/setLeaveSupportConfig`,
  // 是否已配置教职工请假
  API_SCHOOL_ABSENCE_CONFIG: `${apiHost}/school/config/absence`,

  /** **** 通讯录 *******************/
  // 查询子部门信息
  API_GET_SUB_DEPT: `${apiHost}/school/dept/getSubDept`,
  // 查询子部门信息
  API_GET_CLASS_STUDENT_INFO: `${apiHost}/school/student/getClassStudentInfo`,

  /** **** 电子班牌 *******************/
  // 评比类型列表
  API_GET_SQUIRREL_EVALUATE_TYPE_LIST: `${apiHost}/squirrel/h5/moralEdu/evaluateType/list`,
  // 统计待审核学生评比记录数量
  API_GET_SQUIRREL_EVALUATE_WAIT_APPROVE_COUNT: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/countWaitApprove`,
  // 查询学期考评统计
  API_GET_SQUIRREL_EVALUATE_SCHOOL_TERM_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/getSchoolTermStatistics`,
  // 查询教学周考评统计
  API_GET_SQUIRREL_EVALUATE_WEEK_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/getWeekStatistics`,
  // 查询学生考评统计
  API_GET_SQUIRREL_EVALUATE_STUDENT_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/getStudentStatistics`,
  // 查询学生评比记录列表（分页）
  API_GET_SQUIRREL_EVALUATE_STUDENT_LIST: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/list`,
  // 老师考评学生
  API_SQUIRREL_EVALUATE_STUDENT: `${apiHost}/squirrel/h5/moralEdu/teacherEvaluateStudent`,
  // 修改学生评比记录状态
  API_SQUIRREL_EVALUATE_UPDATE_STUDENT: `${apiHost}/squirrel/h5/moralEdu/studentEvaluate/updateStatus`,
  // 查询学年
  API_SQUIRREL_GET_YEAR_TERM: `${apiHost}/squirrel/h5/schoolItem/yearTeachWeek/list`,
  // 查询教学周列表
  API_GET_SQUIRREL_EVALUATE_TEACH_WEEK_LIST: `${apiHost}/squirrel/h5/schoolItem/teachWeek/list`,
  // 导出学生德育考评记录为Excel（通过工作通知发送给操作人员）
  API_SQUIRREL_EVALUATE_EXPORT_STUDENT: `${apiHost}/squirrel/h5/moralEdu/exportStudentEvaluateExcel`,
  // 查询导出任务状态
  API_GET_SQUIRREL_TASK: `${apiHost}/squirrel/h5/moralEdu/getTaskInfo`,
  // 设置班牌名称
  API_SQUIRREL_DEVICE_NAME: `${apiHost}/squirrel/h5/device/bindName`,
  // 查询班牌详情
  API_GET_SQUIRREL_DEVICE_DETAIL: `${apiHost}/squirrel/h5/device/detail`,
  // 铺路查询班牌详情
  API_BATCH_GET_DEVICE_DETAIL: `${apiHost}/squirrel/h5/getSimpleDeviceInfo`,
  // 班牌列表
  API_GET_SQUIRREL_DEVICE_LIST: `${apiHost}/squirrel/h5/device/list`,
  // 新班牌列表
  API_GET_NEW_SQUIRREL_DEVICE_LIST: `${apiHost}/squirrel/h5/device/familyCall/list`,
  // 批量查询设备在线状态和升级标识
  API_GET_SQUIRREL_DEVICE_UPGRADE_FLAG: `${apiHost}/squirrel/h5/device/batchQueryOnlineStatusAndUpgradeFlag`,
  // 获取版本号
  API_GET_SQUIRREL_DEVICE_NEW_VERSION: `${apiHost}/app/version/getNewVersion`,
  // 获取rom版本号
  API_GET_SQUIRREL_DEVICE_ROM_VERSION_LIST: `${apiHost}/device/version/listDeviceRomVersion`,
  // 获取apk版本号
  API_GET_SQUIRREL_DEVICE_APP_VERSION_LIST: `${apiHost}/device/version/listDeviceAppVersion`,
  // 获取版本号列表
  API_GET_SQUIRREL_DEVICE_NEW_VERSION_LIST: `${apiHost}/app/version/getNewVersionList`,
  // 获取当前版本号详情
  API_GET_SQUIRREL_DEVICE_VERSION_DETAILS: `${apiHost}/app/version/details`,
  // 解绑设备
  API_SQUIRREL_DEVICE_UNBIND_BATCH: `${apiHost}/attence/device/unbind/batch`,
  // 设备版本升级
  API_SQUIRREL_DEVICE_UPGRADE_NEW: `${apiHost}/device/mergeUpgradenew`,
  // 设备批量升级
  API_SQUIRREL_DEVICE_UPGRADE_LIST_NEW: `${apiHost}/device/mergeUpgradenewList`,
  // 查询app升级状态
  API_GET_SQUIRREL_DEVICE_UPGRADE_STATUS: `${apiHost}/device/getMergeUpgradeStatus`,
  // 提交激活二维码
  API_SQUIRREL_DEVICE_QRCODE_UPDATE: `${apiHost}/service/device/qrcode/update`,
  // 获取设备网络状态
  API_GET_SQUIRREL_DEVICE_NETWORK: `${apiHost}/device/networkInfo`,
  // 设备批量解绑
  API_GET_SQUIRREL_DEVICE_UNBIND: `${apiHost}/squirrel/h5/device/unbind/batch`,
  // 获取钉钉版本的设备激活状态
  API_DING_ACTIVE_STATUS: `${apiHost}/service/device/activitystatus/ding`,
  // 获取机构信息
  API_GET_CORPINFO: `${apiHost}/ding/corp/getCorpInfo`,
  // 创建并绑定机构
  API_POST_CORP_BIND: `${apiHost}/corp/createAndBindOrg`,
  // 设备网络状态
  API_DEVICES_NET_STATUS: `${apiHost}/device/list/status`,
  // 获取班牌的 appType
  API_GET_PAD_APP_TYPE: `${apiHost}/squirrel/h5/device/getClassPadAppType`,
  // 设备重启接口
  API_DEVICE_RE_BOOT: `${apiHost}/squirrel/h5/device/reBoot`,
  // 校区下有哪些模式的班牌
  API_GET_DEVICE_MODE: `${apiHost}/squirrel/h5/device/ModeExist/get`,
  // 宿舍楼下的班牌列表
  API_DEVICE_DORM_BUILDING: `${apiHost}/squirrel/h5/device/classPadsInDormBuilding`,
  // 班牌设备额外配置信息
  API_H5_GET_DEVICE_EXTRA_INFO: `${apiHost}/squirrel/h5/getDeviceExtraInfo`,
  // 修改班牌设备额外配置信息
  API_H5_UPDATE_DEVICE_EXTRA_INFO: `${apiHost}/squirrel/h5/updateDeviceExtraInfo`,
  // 获取考评老师的考评类型列表
  API_GET_SQUIRREL_MORAL_LIST_TEACHER_MORAL_EDU_EVALUATION_GROUP: `${apiHost}/squirrel/h5/moralEdu/evaluationType/listTeacherMoralEduEvaluationGroup`,
  // 导出德育报表为Excel
  API_GET_SQUIRREL_MORAL_EXPORT: `${apiHost}/squirrel/h5/moral/exportMoralRecordExcel`,

  // 获取学生个人学期考评总计
  API_GET_SQUIRREL_MORAL_STUDENT_TERM_EVALUATION_TOTAL_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/getMoralEduStudentTermEvaluationTotalStatistics`,
  // 获取学生个人周考评总计
  API_GET_SQUIRREL_MORAL_STUDENT_WEEK_EVALUATION_TOTAL_SATTISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/getMoralEduStudentWeekEvaluationTotalStatistics`,
  // 查询班级学生学期考评统计
  API_GET_SQUIRREL_MORAL_LIST_CLASS_TERM_EVALUATION_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/listClassTermEvaluationStatistics`,
  // 查询班级学生周考评统计
  API_GET_SQUIRREL_MORAL_LIST_CLASS_WEEK_EVALUATION_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/listClassWeekMoralEduStatistics`,
  // 查询部门学期考评统计
  API_GET_SQUIRREL_MORAL_LIST_DEPT_TERM_EVALUATION_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/listDeptTermEvaluationStatistics`,
  // 查询部门周考评统计
  API_GET_SQUIRREL_MORAL_LIST_DEPT_WEEK_EVALUATION_STATISTICS: `${apiHost}/squirrel/h5/moralEdu/statistics/listDeptWeekEvaluationStatistics`,
  // 统计待审核学生评比记录数量
  API_GET_SQUIRREL_MORAL_COUNT_WAIT_APPROVE: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/countWaitApprove`,
  // 查询学生考评记录明细
  API_GET_SQUIRREL_MORAL_QUERY_STUDENT_EVALUATION_DETAIL: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/queryStudentMoralEduEvaluationDetail`,
  // 修改学生评比记录状态
  API_POST_SQUIRREL_MORAL_STUDENT_EVALUATION_UPDATE_STATUS: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/updateStatus`,
  // 获取学生德育评比申请记录
  API_GET_SQUIRREL_MORAL_GET_STUDENT_SIMPLE_EVALUATION_RECORD: `${apiHost}/squirrel/h5/moralEdu/teacherEvaluation/getStudentSimpleEvaluationRecord`,
  // 获取班级-年级信息
  API_GET_GRADE_LIST: `${apiHost}/squirrel/grade/list`,
  // 获取考评老师德育评比记录
  API_GET_SQUIRREL_MORAL_LIST_SIMPLE_EVALUATION_RECORD: `${apiHost}/squirrel/h5/moralEdu/teacherEvaluation/queryTeacherSimpleEvaluationRecord`,
  // 获取考评老师德育评比记录-我的考评新增
  API_GET_SQUIRREL_MORAL_LIST_EVALUATION_RECORD: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/listEvaluationRecord`,
  // 获取德育申请记录
  API_GET_SQUIRREL_MORAL_QUERY_SIMPLE_EVALUATION_RECORD: `${apiHost}/squirrel/h5/moralEdu/teacherEvaluation/querySimpleEvaluationRecord`,
  // 老师考评学生
  API_POST_SQUIRREL_MORAL_TEACHER_EVALUATION_STUDENT: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/teacherEvaluationStudent`,
  // 老师批量考评学生
  API_POST_SQUIRREL_MORAL_TEACHER_BATCH_EVALUATION_STUDENT: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/teacherBatchEvaluationStudent`,
  // 表扬和待改进记录
  API_GET_EVALUATION_LIST: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/getEvaluationRecord`,

  API_DELETE_EVALUATION_LIST: `${apiHost}/squirrel/h5/moralEdu/studentEvaluation/deleteEvaluationRecord`,

  // 人脸识别
  API_POST_SQUIRREL_MORAL_RECOGNIZE_FACE: `${apiHost}/squirrel/h5/recognize/search`,
  API_POST_SCHOOL_RECOGNIZE_FACE: `${apiHost}/school/h5/recognize/search`,
  // 查询评比项目
  API_GET_SQUIRREL_EVALUATION_TYPE_LIST: `${apiHost}/squirrel/h5/classEvaluation/evaluationType/list`,
  // 老师评比班级
  API_POST_SQUIRREL_EVALUATION_TEACHER: `${apiHost}/squirrel/h5/classEvaluation/teacherEvaluationClass`,
  // 部门统计（支持查询校区下的年级统计、年级下的班级统计 适用于管理员角色）
  API_GET_DEPT_STATISTICS: `${apiHost}/squirrel/classEvaluation/statistics/getDeptStatistics`,
  // 查询部门树（年级 -> 班级 -> 查询当天的该班级的班级评比记录列表）
  API_GET_DEPT_TREE_BY_ROLE: `${apiHost}/squirrel/classEvaluation/statistics/getDeptTreeByRole`,
  // 班级评比导出统计报表（通过工作通知发送给操作人员）
  API_CLASSRANK_EXPORT: `${apiHost}/squirrel/classEvaluation/exportExcel`,
  // 班级评比撤销当天记录
  API_CLASSRANK_BACKOUT: `${apiHost}/squirrel/h5/classEvaluation/backOut`,
  // 部门统计（适用于值周老师、班主任角色）
  API_GET_DEPT_STATISTICS_BY_ROLE: `${apiHost}/squirrel/classEvaluation/statistics/getDeptStatisticsByRole`,
  // 班级周总分统计
  API_GET_SQUIRREL_EVALUATION_FITURE_STATISTICS_LIST: `${apiHost}/squirrel/classEvaluation/statistics/listClassWeekScoreEvaluationRecordStatistics`,
  //  班级周统计与流水(周)
  API_GET_SQUIRREL_EVALUATION_CLASS_WEEK_STATISTICS_FLOW: `${apiHost}/squirrel/classEvaluation/statistics/listClassWeekStatisticsWithRecord`,

  API_CLASSRANK_GET_AUDIT_MEMBER_CONFIG: `${apiHost}/squirrel/h5/classEvaluation/getAuditMemberConfig`,
  API_CLASSRANK_SAVE_AUDIT_MEMBER_CONFIG: `${apiHost}/squirrel/h5/classEvaluation/saveAuditMemberConfig`,
  API_CLASSRANK_GET_AUDIT_SHOW_CONFIG: `${apiHost}/squirrel/h5/classEvaluation/getDetailShowInClassPadConfig`,
  API_CLASSRANK_SAVE_AUDIT_SHOW_CONFIG: `${apiHost}/squirrel/h5/classEvaluation/saveDetailShowInClassPadConfig`,
  API_CLASSRANK_GET_AUDIT_LIST: `${apiHost}/squirrel/h5/classEvaluation/getClassRecordList`,
  API_CLASSRANK_SAVE_AUDIT: `${apiHost}/squirrel/h5/classEvaluation/batchUpdateAuditStatus`,

  // 创建学生家长单聊会话
  API_GET_SQUIRREL_CHAT_CREATE: `${apiHost}/squirrel/h5/chat/group/createS1G1Group`,
  // 查用户参于的的有聊天组
  API_GET_SQUIRREL_CHAT_QUERY_GROUP: `${apiHost}/squirrel/h5/chat/group/queryChat2pPeerUser`,
  // 消息撤回
  API_GET_SQUIRREL_CHAT_CANCEL: `${apiHost}/squirrel/h5/chat/message/cancel`,
  // 查用户参于的的有聊天组
  API_GET_SQUIRREL_CHAT_QUERY: `${apiHost}/squirrel/h5/chat/message/query`,
  // 学生家长1:1会话发消息
  API_GET_SQUIRREL_CHAT_SEND: `${apiHost}/squirrel/h5/chat/message/send`,
  // 标记已读
  API_GET_SQUIRREL_CHAT_MARKREAD: `${apiHost}/squirrel/h5/chat/message/markRead`,
  // 重置沙盒状态，当沙盒变更处理超时时，要调些接口
  API_SANDBOX_RESET: `${apiHost}/school/sandbox/groupTree/resetStatus`,

  // 统计校区班牌数量
  API_GET_SQUIRREL_DEVICES: `${apiHost}/squirrel/h5/device/countByCampus`,

  /** **** 放学管理 *******************/
  // 查询家长到校签到配置
  API_GET_STUDENT_LEAVE_RULES: `${apiHost}/school/h5/afterSchool/config/getGuardianFlexleaveSignConfig`,
  // 查询学生放学计划
  API_GET_STUDENT_LEAVE_PLANS: `${apiHost}/school/h5/afterSchool/config/getStudentFlexLeavePlan`,
  // 保存家长到校签到配置
  API_SAVE_STUDENT_LEAVE_RULES: `${apiHost}/school/h5/afterSchool/config/saveGuardianFlexleaveSignConfig`,
  // 查询老师刷脸门禁设备已选中数量
  API_GET_HEADER_MASTER_FACE_DEVICE_COUNT: `${apiHost}/school/h5/afterSchool/config/getAdviserDeviceSelectedNum`,
  // 查询学生进入等候区刷脸设备已选中数量
  API_GET_STUDENT_WAIT_FACE_DEVICE_COUNT: `${apiHost}/school/h5/afterSchool/config/getStudentEnterWaitingAreaDeviceSelectedNum`,
  // 删除学生放学计划
  API_STUDENT_LEAVE_PLAN: `${apiHost}/school/h5/afterSchool/config/deleteDeviceEnableTimeSchedule`,
  // 查询班牌设备放学模块配置
  API_GET_AUTO_CLASS_DEVICE_CONFIG: `${apiHost}/school/h5/afterSchool/config/getClassPadAfterSchoolConfig`,
  // 保存班牌设备放学模块配置
  API_SAVE_AUTO_CLASS_DEVICE_CONFIG: `${apiHost}/school/h5/afterSchool/config/saveClassPadAfterSchoolConfig`,
  // 查询班级自动放学配置
  API_GET_AUTO_CLASS_OVER_CONFIG: `${apiHost}/school/h5/afterSchool/config/getAutoClassOverConfig`,
  // 保存班级自动放学配置
  API_SAVE_AUTO_CLASS_OVER_CONFIG: `${apiHost}/school/h5/afterSchool/config/saveAutoClassOverConfig`,
  // 查询学生留堂列表
  API_DETENTION_STUDENT_LIST: `${apiHost}/school/h5/detentionStudent/list`,
  // 删除学生留堂列表
  API_DELETE_DETENTION_STUDENT: `${apiHost}/school/h5/detentionStudent/delete`,
  // 添加学生留堂列表
  API_ADD_DETENTION_STUDENT: `${apiHost}/school/h5/detentionStudent/add`,
  // 查询班级放学状态
  API_GET_AFTER_SCHOOL_STATUS: `${apiHost}/school/h5/afterSchool/getClassStatus`,
  // 开始放学
  API_START_AFTER_SCHOOL: `${apiHost}/school/h5/afterSchool/start`,
  // 放学班级统计
  API_GET_STAT_AFTER_SCHOOL_CLASS: `${apiHost}/school/h5/afterSchool/listGradeDayStatistics`,
  // 放学接送通知列表
  API_GET_AFTER_SCHOOL_PICKUP_LIST: `${apiHost}/school/h5/afterSchool/getAfterSchoolPickupList`,
  // 通知详情的业务扩展
  API_AFTER_SCHOOL_NOTICE: `${apiHost}/school/notice/saveBizData`,
  // 查询班主任刷脸设备
  API_GET_HEADER_MASTER_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/listAdviserDevice`,
  // 保存班主任刷脸设备
  API_SAVE_ADVISERDEVICE: `${apiHost}/school/h5/afterSchool/config/saveAdviserDevice`,
  // 查询学生刷脸设备
  API_GET_STUDENT_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/listStudentLeaveDevice`,
  // 保存学生刷脸设备
  API_SAVE_STUDENT_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/saveStudentLeaveDevice`,
  // 查询等候区设备
  API_GET_WAITING_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/listStudentEnterWaitingAreaDevice`,
  // 保存等候区设备
  API_SAVE_WAITING_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/saveStudentEnterWaitingAreaDevice`,
  // 查询家长刷脸设备
  API_GET_GUARDIAN_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/getGuardianDevice`,
  // 保存家长刷脸设备
  API_SAVE_GUARDIAN_FACE_DEVICE: `${apiHost}/school/h5/afterSchool/config/saveGuardianDevice`,
  // 查询设备启用时间
  API_GET_DEVICE_ENABLE_TIME: `${apiHost}/school/h5/afterSchool/config/getDeviceEnableTime`,
  // 新增放学计划
  API_ADD_DEVICE_ENABLE_TIME: `${apiHost}/school/h5/afterSchool/config/addDeviceEnableTime`,
  // 保存设备启用时间
  API_SAVE_DEVICE_ENABLE_TIME: `${apiHost}/school/h5/afterSchool/config/saveDeviceEnableTime`,
  // 保存学生离校时间
  API_SAVE_NOTICE_TIME: `${apiHost}/school/h5/afterSchool/config/saveStudentLeaveSchoolTime`,
  // 获取当前时间选修班状态 get
  API_ELECTIVE_CLASS_STATUS: `${apiHost}/school/h5/afterSchool/electiveClassStatus`,
  // 根据角色获取选修班列表 get
  API_ELECTIVE_CLASS_LIST: `${apiHost}/school/h5/afterSchool/listElectiveClass`,
  // 选修班开始放学 post
  API_ELECTIVE_CLASS_START: `${apiHost}/school/h5/afterSchool/electiveClass/start`,
  // 获取当前机构选修班放学开始时间 get
  API_ELECTIVE_GET_LEAVE_TIME: `${apiHost}/school/h5/afterSchool/config/electiveClassFlexLeaveStartTime`,
  // 保存当前机构选修班放学开始时间 post
  API_ELECTIVE_SET_LEAVE_TIME: `${apiHost}/school/h5/afterSchool/config/saveElectiveClassFlexLeaveStartTime`,
  // 我已到校
  API_ARRIVED_SCHOOL: `${apiHost}/school/flexleave/biz/guardianArrival`,
  // 判断机构下是否有门禁设备
  API_JUDGE_HAS_ENTRANCE_DEVICE: `${apiHost}/school/h5/device/hasDevice`,
  API_CLASSCARD_TEMPLATE_LIST: `${apiHost}/squirrel/h5/classPadTemplate/list`,

  // 取消发布
  API_CLASSCARD_PUBLISH_CANCEL_PUBLISH: `${apiHost}/squirrel/h5/publish/cancelPublish`,
  // 获取班牌部门子节点
  API_CLASSCARD_PUBLISH_GET_SUB_NODE: `${apiHost}/squirrel/h5/publish/getDeptTreeSubNode`,
  // 获取一个完整班牌树 金典校区学段-年级-班牌，自定义校区a部门-b部门-xx部门-班级上一级部门-班牌
  API_CLASSCARD_GET_PAD_TREE: `${apiHost}/squirrel/h5/publish/getClassPadDeptTree`,
  // 进行发布
  API_CLASSCARD_PUBLISH_DO_PUBLISH: `${apiHost}/squirrel/h5/publish/doPublish`,
  // 获取发布详情
  API_CLASSCARD_PUBLISH_GET_PUBLISH_DETAIL: `${apiHost}/squirrel/h5/publish/getPublishDetail`,
  // 获取班主任可展示的班牌列表
  API_CLASSCARD_PUBLISH_ADVISER_CLASSPAD: `${apiHost}/squirrel/h5/publish/listAdviserClassPad`,
  // 获取内容发布记录(分页)
  API_CLASSCARD_PUBLISH_LIST_PAGE: `${apiHost}/squirrel/h5/publish/listPage`,
  // 查看选中的班牌，按学段分类，展示班牌
  API_CLASSCARD_PUBLISH_SELECTED_CLASSPAD: `${apiHost}/squirrel/h5/publish/listSelectedClassPad`,
  // 查看显示的班牌，按学段分类，展示班牌
  API_CLASSCARD_PUBLISH_SHOW_CLASSPAD: `${apiHost}/squirrel/h5/publish/listShowClassPad`,
  // 搜索班牌列表
  API_CLASSCARD_PUBLISH_SEARCH_CLASSPAD: `${apiHost}/squirrel/h5/publish/searchClassPad`,
  // 获取班牌配置详情
  API_CLASSCARD_GET_CONFIG_DETAIL: `${apiHost}/squirrel/h5/device/getClassPadConfigDetail`,
  // 判断选中的班牌是否被其他班牌设置使用
  API_CLASSCARD_JUDGE_HAS_USE: `${apiHost}/squirrel/h5/device/judgeClassPadHasUse`,
  // 获取班牌配置
  API_CLASSCARD_GET_CONFIG_LIST: `${apiHost}/squirrel/h5/device/listClassPadConfig`,
  // 添加班牌配置
  API_CLASSCARD_ADD_CONFIG: `${apiHost}/squirrel/h5/device/saveClassPadConfig`,
  // 编辑班牌配置
  API_CLASSCARD_UPDATE_CONFIG: `${apiHost}/squirrel/h5/device/updateClassPadConfig`,
  // 删除班牌配置
  API_CLASSCARD_DELETE_CONFIG: `${apiHost}/squirrel/h5/device/deleteClassPadConfig`,
  // H5端扫码，将机构更新到二维码中
  API_DEVICE_UPDATE_QRCODE: `${apiHost}/service/device/qrcode/update`,
  // H5端获取激活的状态，轮询操作
  API_DEVICE_UPDATE_ACTIVE_STATUS: `${apiHost}/service/device/activitystatus`,
  // 获取设备后台离线密码
  API_DEVICE_OFFLINE_PASSWORD: `${apiHost}/attence/admin/config/password`,
  // 取消指令
  API_COMMAND_CANCEL: `${apiHost}/school/h5/command/cancel`,
  // 查询指令
  API_COMMAND_QUERY: `${apiHost}/school/h5/command/query`,
  // 发送指令
  API_COMMAND_SEND: `${apiHost}/school/h5/command/send`,
  // 上报日志接口
  API_COMMAND_LOG: `${apiHost}/school/h5/command/log`,
  // 新留言查询
  API_MESSAGE_QUERY: `${apiHost}/squirrel/di/chat/message/queryNewLeaveMsg`,
  // 查询设备模式详情
  API_DEVICEMODEL_DETAIL: `${apiHost}/squirrel/h5/deviceModel/detail`,
  // 设备模式-获取所有校区以及校区下的班级数量
  API_DEVICEMODEL_CAMPUS_CLASS_COUNT: `${apiHost}/squirrel/h5/deviceModel/listAllCampusAndClassCount`,
  // 设备模式-保存班牌绑定范围
  API_DEVICEMODEL_SAVE: `${apiHost}/squirrel/h5/deviceModel/saveClassPadBindRange`,
  // 获取学生荣誉绑定设备
  API_STUDENTHONOUR_DEVICE_LIST: `${apiHost}/squirrel/h5/studentHonour/device/list`,
  // 学生荣誉取消发布
  API_Honour_CANCEL: `${apiHost}/squirrel/h5/studentHonour/cancelPublish`,
  // 获取学生荣誉发布记录(分页)
  API_HONOUR_LIST: `${apiHost}/squirrel/h5/studentHonour/listPage`,
  // 学生荣誉发布
  API_HONOUR_PUBLISH: `${apiHost}/squirrel/h5/studentHonour/publish`,
  // 设置设备名称
  API_SAVE_DEVICE_NAME: `${apiHost}/squirrel/h5/device/saveDeviceName`,
  // 查询年度学年学期
  API_GET_SCHOOL_YEAR_TERM_LIST: `${apiHost}/squirrel/h5/schoolYearTerm/list`,
  // 升级学年
  API_GET_YEAR_UPDATE: `${apiHost}/squirrel/h5/yearUpdate`,
  // 是否可升级学年
  API_GET_IS_YEAR_UPDATE: `${apiHost}/squirrel/h5/isYearUpdate`,
  // 查询学年结束时间
  API_GET_SCHOOL_YEAR_END_DATE: `${apiHost}/squirrel/h5/schoolYear/endDate`,
  API_GET_SCHOOL_TERM: ``,
  API_LEAVE_DETAIL: ``,
  // 保存或者更新学年学期
  API_SVAE_SCHOOL_TERM: `${apiHost}/squirrel/h5/term/saveOrUpdate`,
  // 获取校区下亲情通话设置
  API_GET_CALL_SETTING: `${apiHost}/squirrel/h5/familyCall/setting/get`,
  // 保存校区下亲情通话设置
  API_SAVE_CALL_SETTING: `${apiHost}/squirrel/h5/familyCall/setting/saveOrUpdate`,
  // 设备通话管理 获取设备列表
  API_GET_DEVICE_LIST: `${apiHost}/squirrel/h5/familyCall/device/list`,
  // 保存校区下设备通话设置
  API_SAVE_CALL_DEVICE_SETTING: `${apiHost}/squirrel/h5/familyCall/setting/saveOrUpdateDevice`,
  // 年级统计（教学周）
  API_GET_CALL_GRADE: `${apiHost}/squirrel/h5/familyCall/stat/getGradesStat`,
  // 班级统计（教学周）
  API_GET_CALL_CLASS: `${apiHost}/squirrel/h5/familyCall/stat/getClassesStat`,
  // 班级通话详情（教学周）
  API_GET_CALL_CLASS_DETAIL: `${apiHost}/squirrel/h5/familyCall/stat/getClassDetail`,
  // 班级统计（教学周）
  API_GET_CALL_STUDENT_DETAIL: `${apiHost}/squirrel/h5/familyCall/stat/getStuDetail`,
  // 个人通话历史记录明细
  API_GET_CALL_STUDENT_RECORD: `${apiHost}/squirrel/h5/familyCall/stat/getStuDetailByDimDay`,
  // 查询某个学生是否存在亲情通话记录,按时间排序从1号开始一直到当前日 1：存在 0：不存在
  API_GET_CALL_STUDENT_CALENDAR: `${apiHost}/squirrel/h5/familyCall/stat/getCalendar`,
  // 批量保存页面浏览记录
  API_SAVE_PAGE_VIEW_BATCH: `${apiHost}/canary/pageView/saveBatch`,
  // 查询自然周
  API_GET_NATURAL_WEEK: `${apiHost}/squirrel/h5/familyCall/familyCallWeek/list`,
  // 查询机构下，视频通话配置开关
  API_GET_SETTING_SWITCH: `${apiHost}/squirrel/h5/familyCall/setting/switch`,
  // 查询未设置班主任的班级列表
  API_GET_SETTING_NO_ADVISER_CLASS: `${apiHost}/squirrel/h5/familyCall/listNoAdviserClass`,
  // 查询老师课堂评价统计（跨校区统计）
  API_CLASS_EVALUATION_GET_TEACHER_STAT: `${apiHost}/squirrel/h5/courseEvaluation/getTeacherStat`,
  // 课堂评价导出统计报表（通过工作通知发送给操作人员）
  API_COURSE_EVALUATION_EXPORT: `${apiHost}/squirrel/h5/courseEvaluation/exportExcel`,
  // 管理员-校区+年级统计
  API_CLASS_EVALUATION_GRADE_STA: `${apiHost}/squirrel/h5/courseEvaluation/getCampusGradeStat`,
  // 班级详情(科目 & 学生平均分)
  API_CLASS_EVALUATION_CLASS_DETAILS: `${apiHost}/squirrel/h5/courseEvaluation/getClassDetails`,
  // 获取课程学生平均分详情
  API_CLASS_EVALUATION_COURSE_DETAILS: `${apiHost}/squirrel/h5/courseEvaluation/getCourseDetails`,
  // 管理员-年级+班级统计
  API_CLASS_EVALUATION_CLASS_STA: `${apiHost}/squirrel/h5/courseEvaluation/getGradeClassStat`,
  // 老师- 我的评价详情
  API_CLASS_EVALUATION_DETAILS_TEACHER: `${apiHost}/squirrel/h5/courseEvaluation/getMyEvaluationDetails`,
  // 老师- 我的评价列表
  API_CLASS_EVALUATION_LIST_TEACHER: `${apiHost}/squirrel/h5/courseEvaluation/getMyEvaluationList`,
  // 老师- 我的评价批量提交
  API_CLASS_EVALUATION_SAVE_BEATCH: `${apiHost}/squirrel/h5/courseEvaluation/doEvaluation`,
  // 查询时间段内存在老师的课程
  API_CLASS_EVALUATION_TEACHER_COURSE_LIST: `${apiHost}/squirrel/h5/courseEvaluation/getCourseList`,
  // 校区班级光盘记录统计
  API_CLEARPLATE_GET_CAMPUS_CLASS_STA: `${apiHost}/squirrel/h5/clearPlate/getStatCampusClass`,
  // 校区年级光盘记录统计
  API_CLEARPLATE_GET_CAMPUS_STA: `${apiHost}/squirrel/h5/clearPlate/getStatCampusGrade`,
  // 班级光盘明细 记录统计
  API_CLEARPLATE_GET_CLASS_STA: `${apiHost}/squirrel/h5/clearPlate/getStatClassDetail`,
  // 年级班级光盘记录统计
  API_CLEARPLATE_GET_GRADE_STA: `${apiHost}/squirrel/h5/clearPlate/getStatGradeClass`,
  // 个人光盘记录统计
  API_CLEARPLATE_GET_USER_STA: `${apiHost}/squirrel/h5/clearPlate/getStatUser`,
  // 个人光盘记录明细
  API_CLEARPLATE_GET_USER_DETAIL: `${apiHost}/squirrel/h5/clearPlate/getStatUserDetail`,

  // 查看选课活动公告
  API_ELECTIVE_ACTIVITY_ANNOUNCE: `${apiHost}/squirrel/h5/selectCourseActivity/getActivityAnnouncement`,
  // 查询学生端某个选课活动的可选选修班
  API_ELECTIVE_ACTIVITY_CLASS_ENABLE_LIST: `${apiHost}/squirrel/h5/selectCourseActivity/listEnableElectiveClass`,
  // 查看学生端选课活动
  API_ELECTIVE_ACTIVITY_ENABLE_LIST: `${apiHost}/squirrel/h5/selectCourseActivity/listStudentEnableActivity`,
  // 取消报名
  API_ELECTIVE_CLASS_CANCEL: `${apiHost}/squirrel/h5/electiveClass/cancelEnterNameById`,
  // 取消报名2
  API_ELECTIVE_CLASS_CANCELByUK: `${apiHost}/squirrel/h5/electiveClass/cancelEnterNameByUk`,
  // 选修班报名
  API_ELECTIVE_CLASS_ENTERNAME: `${apiHost}/squirrel/h5/electiveClass/enterName`,
  // 查询学生的某个选修班详情
  API_ELECTIVE_CLASS_DETAIL: `${apiHost}/squirrel/h5/electiveClass/getStudentElectiveClassDetail`,
  // 查询某选修班下的选课学生
  API_ELECTIVE_CLASS_STUDENT: `${apiHost}/squirrel/h5/electiveClass/listElectiveClassStudent`,
  // 查询某个行政班下的学生的选修班情况
  API_ELECTIVE_CLASS_STUDENT_LIST: `${apiHost}/squirrel/h5/electiveClass/listMajorClassStudentElectiveClass`,
  // 查询学生的选修班
  API_ELECTIVE_STUDENT_CLASS_LIST: `${apiHost}/squirrel/h5/electiveClass/listStudentElectiveClass`,
  // 查询任课老师教的选修班
  API_ELECTIVE_TEACHER_CLASS_LIST: `${apiHost}/squirrel/h5/electiveClass/listTeacherElectiveClass`,
  // 查询学生端某个选课活动的选修班类型
  API_ELECTIVE_CLASSTYPES: `${apiHost}/squirrel/h5/selectCourseActivity/listElectiveClassType`,
  // 校巴通知
  API_SCHOOL_BUS_NOTICE_DETAIL: `${apiHost}/school/notice/getNoticeDetail`,
  // 统计某校区下的年级选修人数
  API_ELECTIVE_CLASS_CAMPUS_GRADE_STAT: `${apiHost}/squirrel/h5/electiveClass/campusGradeStat`,
  // 统计某校区下的班级选修人数
  API_ELECTIVE_CLASS_GRADE_CLASS_STAT: `${apiHost}/squirrel/h5/electiveClass/gradeClassStat`,

  // 课表
  // 班級课表
  API_SCHEDULE_CLASS_DETAILS: `${apiHost}/squirrel/h5/course/class/details`,
  // 课程班级信息-列表
  API_SCHEDULE_CLASS_LIST: `${apiHost}/squirrel/h5/course/class/list`,
  // 教师课表
  API_SCHEDULE_TEACHER_DETAILS: `${apiHost}/squirrel/h5/course/teacher/details`,
  // 课程老师信息-列表
  API_SCHEDULE_TEACHER_LIST: `${apiHost}/squirrel/h5/course/teacher/list`,
  // 查询当前用户是否为任课老师
  API_SCHEDULE_IS_TEACHER: `${apiHost}/squirrel/h5/course/teacher/isSquirrelTeacher`,
  // 获取企业下的自定义空间
  API_GET_CORP_USER_CUSTOM_SPACE: `${apiHost}/corpUser/getCustomSpace`,

  // 提交调代课申请
  API_SCHEDULE_SUBSTITUTE_APPLICATION: `${apiHost}/squirrel/h5/schedule/substitute/application`,
  // 校验调代课详情中是否有已经被关联的课程
  API_SCHEDULE_SUBSTITUTE_CHECKEXISTSUBSTITUTESECTION: `${apiHost}/squirrel/h5/schedule/substitute/checkExistSubstituteSection`,
  // 安排调代课
  API_SCHEDULE_SUBSTITUTE_ARRANGE: `${apiHost}/squirrel/h5/schedule/substitute/arrange`,
  // 删除调代课申请
  API_SCHEDULE_SUBSTITUTE_DELETE: `${apiHost}/squirrel/h5/schedule/substitute/delete`,
  // 查询班级课表
  API_SCHEDULE_SUBSTITUTE_GETCLASSSCHEDULE: `${apiHost}/squirrel/h5/schedule/substitute/getClassSchedule`,
  // 查询调代课申请详情
  API_SCHEDULE_SUBSTITUTE_GETDETAIL: `${apiHost}/squirrel/h5/schedule/substitute/getDetail`,
  // 查询调代课个人统计汇总
  API_SCHEDULE_SUBSTITUTE_GETPERSONALSTATISTICS: `${apiHost}/squirrel/h5/schedule/substitute/getPersonalStatistics`,
  // 查询老师课表
  API_SCHEDULE_SUBSTITUTE_GETTEACHERSCHEDULE: `${apiHost}/squirrel/h5/schedule/substitute/getTeacherSchedule`,
  // 查询老师节次列表（某学期一段时间内的课表）
  API_SCHEDULE_SUBSTITUTE_GETTEACHERSECTIONLIST: `${apiHost}/squirrel/h5/schedule/substitute/getTeacherSectionList`,
  // 查询调代课老师统计汇总
  API_SCHEDULE_SUBSTITUTE_GETTEACHERSTATISTICS: `${apiHost}/squirrel/h5/schedule/substitute/getTeacherStatistics`,
  // 查询调代课明细列表
  API_SCHEDULE_SUBSTITUTE_LISTITEM: `${apiHost}/squirrel/h5/schedule/substitute/listItem`,
  // 分页查询调代课申请列表
  API_SCHEDULE_SUBSTITUTE_LISTPAGE: `${apiHost}/squirrel/h5/schedule/substitute/listPage`,
  // 查询班级列表（支持按校区、年级查询，支持指定显示在最前面的班级DingId）
  API_SCHEDULE_SUBSTITUTE_QUERYCLASS: `${apiHost}/squirrel/h5/schedule/substitute/queryClass`,
  // 根据班级id和节次信息查询班级任课老师（包含是否存在冲突）
  API_SCHEDULE_SUBSTITUTE_QUERYCLASSTEACHERWITHCONFLICT: `${apiHost}/squirrel/h5/schedule/substitute/queryClassTeacherWithConflict`,
  // 根据课程id和节次信息查询老师列表（包含是否存在冲突）
  API_SCHEDULE_SUBSTITUTE_QUERYCOURSETEACHERWITHCONFLICT: `${apiHost}/squirrel/h5/schedule/substitute/queryCourseTeacherWithConflict`,
  // 搜索任课老师（包含是否存在冲突）
  API_SCHEDULE_SUBSTITUTE_SEARCHTEACHERWITHCONFLICT: `${apiHost}/squirrel/h5/schedule/substitute/searchTeacherWithConflict`,
  // 班級课表
  API_SCHEDULE_CLASS_DETAILS_V2: `${apiHost}/squirrel/h5/schedule/class/details`,
  // 教师课表
  API_SCHEDULE_TEACHER_DETAILS_V2: `${apiHost}/squirrel/h5/schedule/teacher/details`,
  // 查询课程列表（只返回课程id、课程名称）
  API_SCHEDULE_COURSE_SIMPLE_LIST: `${apiHost}/squirrel/h5/schedule/course/simpleList`,
  // 查询班级列表（支持按校区、年级查询，支持指定显示在最前面的班级DingId）
  API_COMMON_QUERY_CLASS: `${apiHost}/squirrel/common/queryClass`,
  // 查询课程列表（只返回课程id、课程名称）
  API_COURSE_SIMPLE_LIST: `${apiHost}/squirrel/h5/course/simpleList`,
  // 更新调代课申请状态（撤销、退回）
  API_SCHEDULE_SUBSTITUTE_UPDATESTATUS: `${apiHost}/squirrel/h5/schedule/substitute/updateStatus`,
  // 查询教师课表出现班级的最大节次数
  API_SCHEDULE_TEACHER_GETMAXSECTIONNUM: `${apiHost}/squirrel/h5/schedule/teacher/getMaxSectionNum`,
  // 发送验证码
  API_COMMON_SMS_SEND_CHECK_CODE: `${apiHost}/school/common/sms/sendCheckCode`,
  // 校验验证码
  API_COMMON_SMS_VALID_CHECK_CODE: `${apiHost}/school/common/sms/validCheckCode`,
  API_SCHEDULE_GET_NOTIFY_CONFIG: `${apiHost}/squirrel/h5/schedule/getTomorrowNotifyConfig`,
  API_SCHEDULE_SAVE_NOTIFY_CONFIG: `${apiHost}/squirrel/h5/schedule/saveTomorrowNotifyConfig`,
  // 领取礼包
  API_COMMON_RECEIVE: `${apiHost}/school/common/gift/receive`,

  // 每日食谱详情 get
  API_RECIPES_DAILY_DETAIL: `${apiHost}/squirrel/h5/recipes/daily/detail`,
  // 食谱发布状态列表 get
  API_RECIPES_DAILY_STATUS: `${apiHost}/squirrel/h5/recipes/daily/states`,
  // 删除食谱 post
  API_RECIPES_DELETE: `${apiHost}/squirrel/h5/recipes/delete`,
  // 餐点类型列表 get
  API_RECIPES_MEAL_TYPES: `${apiHost}/squirrel/h5/recipes/meal/types`,
  // 保存食谱 post
  API_RECIPES_SAVE: `${apiHost}/squirrel/h5/recipes/save`,
  // 批量添加菜品 post
  API_RECIPES_CUISINE_BATCH_ADD: `${apiHost}/squirrel/h5/recipes/cuisine/batchAdd`,
  // 删除菜品 post
  API_RECIPES_CUISINE_DELETE: `${apiHost}/squirrel/h5/recipes/cuisine/delete`,
  // 菜品详情 get
  API_RECIPES_CUISINE_GET: `${apiHost}/squirrel/h5/recipes/cuisine/get`,
  // 菜品列表 get
  API_RECIPES_CUISINE_PAGE: `${apiHost}/squirrel/h5/recipes/cuisine/page`,
  // 菜品搜索 get
  API_RECIPES_CUISINE_SEARCH: `${apiHost}/squirrel/h5/recipes/cuisine/search`,
  // 菜品分类列表 get
  API_RECIPES_CUISINE_TYPES: `${apiHost}/squirrel/h5/recipes/cuisine/types`,
  // 单个编辑菜品 post
  API_RECIPES_CUISINE_UPDATE: `${apiHost}/squirrel/h5/recipes/cuisine/update`,
  // 获取通知设置 get
  API_RECIPES_CONFIG_GET: `${apiHost}/squirrel/h5/recipes/config/get`,
  // 保存设置 post
  API_RECIPES_CONFIG_SAVE: `${apiHost}/squirrel/h5/recipes/config/save`,
  // 上传临时文件
  API_UPLOAD_TEMPORARY_FILE: `${apiHost}/common/uploadTempFile`,
  // bannerList
  API_CUSTOM_GET_BANNER_LIST: `${backStageHost}/custom/banner/list`,
  // H5通知待办
  API_UPCOMING_LIST: `${apiHost}/school/h5/upcoming/list`,
  // H5消息中心
  API_MESSAGE_FLOW: `${apiHost}/school/h5/message/flow`,
  // 查询今日请假状态
  API_LEAVE_GET_TODAY_LEAVE_STATUS: `${apiHost}/leave/getTodayLeaveStatus`,
  // 消除公告弹窗的配置
  API_ANNOUNCEMENT_CLEAR_MODULE: `${apiHost}/school/announcement/clearModulePopup`,
  // 查询某人公告弹窗的配置集合
  API_ANNOUNCEMENT_MODULE: `${apiHost}/school/announcement/listModulePopup`,

  // 根据短链获取校区信息
  API_GET_SHORT_LINK_INFO: `${apiHost}/school/pikachu/healthPrevention/queryCampusInfoByShortLink`,
  // 筛选范围
  API_H5_ROLE_GROUP_USER_RANGE: `${apiHost}/school/h5/role/group/user/range`,
  // 用户老师角色
  API_H5_ROLE_GET_TEACHER_ROLE: `${apiHost}/school/h5/role/getTeacherRole`,
  // 判断家长是否有使用魔点校园的权限
  API_JUDGE_GUARDIAN_APP_AUTH: `${apiHost}/school/authorize/judgeGuardianSchoolAppAuth`,

  // 查询选修班签到详情
  API_H5_ELECTIVE_SIGN_CLASS_DETAIL: `${apiHost}/squirrel/h5/elective/sign/class/detail`,
  // 查询选修班签到情况
  API_H5_ELECTIVE_SIGN_CLASS_LIST: `${apiHost}/squirrel/h5/elective/sign/class/list`,
  // 查询选修班签到统计情况
  API_H5_ELECTIVE_SIGN_CLASS_STAT: `${apiHost}/squirrel/h5/elective/sign/class/stat`,
  // 查询所有需要签到的老师
  API_H5_ELECTIVE_SIGN_GETTEACHERLIST: `${apiHost}/squirrel/h5/elective/sign/getTeacherList`,
  // 通知班主任
  API_H5_ELECTIVE_SIGN_NOTICEADVISER: `${apiHost}/squirrel/h5/elective/sign/noticeAdviser`,
  // 一键签到
  API_H5_ELECTIVE_SIGN_QUICKLY: `${apiHost}/squirrel/h5/elective/sign/quickly`,
  //  学生签到详情
  API_H5_ELECTIVE_SIGN_STUDENT_DETAIL: `${apiHost}/squirrel/h5/elective/sign/student/detail`,
  // 查询本学期选学生签到统计
  API_H5_ELECTIVE_SIGN_STUDENT_STAT: `${apiHost}/squirrel/h5/elective/sign/student/stat`,
  // 修改签到状态
  API_H5_ELECTIVE_SIGN_UPDATESTATUS: `${apiHost}/squirrel/h5/elective/sign/updateStatus`,

  // 教师签到列表
  API_H5_TEACHER_SIGN_LIST: `${apiHost}/school/notice/getNoticeDetailInfoByTaskId`,

  // 是否展示 班牌考场模式 栏目
  API_H5_GET_SHOW_EXAM: `${apiHost}/squirrel/h5/device/examMode/getShowTag`,
  // 获取 考场模式配置
  API_H5_GET_EXAM_CONFIG: `${apiHost}/squirrel/h5/device/examMode/getConfig`,
  // 变更 考场模式配置
  API_H5_SAVE_EXAM_CONFIG: `${apiHost}/squirrel/h5/device/examMode/updateConfig`,

  /* 微信相关接口-开始 */
  // 获取微信公众号accessToken
  API_WECHAT_GET_AUTH_ACCESS_TOKEN: `${apiHost}/weChat/getOauthAccessToken`,
  // 获取微信公众号用户信息
  API_WECHAT_GET_USER_INFO: `${apiHost}/school/wechat/getUserInfo`,
  // 获取或创建账号
  API_WECHAT_REGISTER_ACCOUNT: `${apiHost}/infrastructure/registerAccountIfNoneForWx`,
  // 获取微信分享短链
  API_WECHAT_SHORT_LINK: `${apiHost}/school/wx/guardian/bind/createShortLink`,
  // 获取班级下所有家长的短码
  API_WECHAT_GET_GUARDIAN_CODE: `${apiHost}/school/wx/guardian/bind/getGuardianCode`,
  // 获取家长下所有学生及对应关系
  API_WECHAT_GET_STUDENTS: `${apiHost}/school/wx/guardian/bind/getStudentRelation`,
  // 家长绑定
  API_WECHAT_BIND: `${apiHost}/school/wxGuardian/bindAndLoginForWx`,
  // 家长解绑
  API_WECHAT_UNBIND: `${apiHost}/school/wx/guardian/unbind`,
  // 获取用户信息
  API_WECHAT_GET_USERINFO: `${apiHost}/school/wxGuardian/getLoginUserInfo`,
  // 判断机构是否开通微信家长端
  API_WECHAT_JUDGEREGISTER: `${apiHost}/school/wx/guardian/judgeRegister`,
  /* 微信相关接口-结束 */
  /** ******************** org **********************/
  // 查询根部门
  API_MAGIC_DEPT_ROOT: `${apiHost}/magic/dept/root`,
  // 查询部门下人员列表 deptIds=1746281029099847680&pageNo=1&pageSize=20
  API_MAGIC_DEPT_LIST: `${apiHost}/magic/member/list`,
  // 查询部门及其子部门ID
  API_MAGIC_DEPT_NODE: `${apiHost}/magic/dept/deptNode`,
  // 查询人脸详情
  API_MAGIC_FACE_EDIT: `${apiHost}/fishnet/person/face/edit`,
  // 删除人脸
  API_MEMBER_DELETE: `${apiHost}/member/deleteByMember`,
  // 删除人脸
  API_MAGIC_FACE_DELETE: `${apiHost}/member/clearFace`,
  // 上传人脸
  API_MAGIC_FACE_UPLOAD: `${apiHost}/member/uploadFace`,
  // 通过unionid登录微信小程序
  API_PERSONAL_CUSTOM_LOGIN_BY_UNIONID: `${apiHost}/custom/loginByUnionid`,
  // 魔蓝-验证账号是否已登录
  API_MAGIC_CUSTOM_CHECK_LOGIN: `${apiHost}/magic/custom/checkLogin`,
  // 查询账号关联机构列表(不包含统计信息)
  API_MAGIC_CUSTOM_LIST_SIMPLE_ORG: `${apiHost}/magic/common/list/simple/org`,
  // 校验用户是否关注过公众号
  API_MAGIC_WECHAT_CHECK_PUBLIC: `${apiHost}/magic/magicube/wechat/program/check/public`,
  // 魔蓝办公小程序登录
  API_PERSONAL_PROGRAM_LOGIN: `${apiHost}/personal/magicube/wechat/program/login`,
  // 魔蓝办公小程序注册
  API_PERSONAL_PROGRAM_REGISTER: `${apiHost}/personal/magicube/wechat/program/register`,
  // 获取微信小程序手机号
  API_PERSONAL_PROGRAM_MOBILE: `${apiHost}/personal/magicube/wechat/program/mobile`,
  // common/account/simpleness
  // 根据账号绑定信息查询账号信息
  API_COMMON_ACCOUNT_SIMPLENESS: `${apiHost}/common/account/simpleness`,
  API_COMMON_ACCOUNT_REGISTER_TOGETHER: `${apiHost}/common/account/register/together`,
  API_COMMON_ACCOUNT_BIND: `${apiHost}/common/account/bind`,
  // 校验微信小程序是否绑定过魔蓝账号通过unionid
  API_WECHAT_PROGRAM_CHECKAUTH: `${apiHost}/magicube/wechat/program/checkAuth`,
  // 根据账号ID查询账号信息
  API_COMMON_ACCOUNT_DETAIL: `${apiHost}/common/account/detail`,
  // 获取机构列表
  // 查询账号主(默认)机构ID
  API_COMMON_ORG_LIST: `${apiHost}/common/queryDefaultOrgByAccountId`,
  // 查询账号关联机构列表
  API_COMMON_ALL_ORG_LIST: `${apiHost}/common/findAllOrgBasicInfoByAccountId`,
  API_MAGIC_MEMBER_INFO: `${apiHost}/magic/member/info`,
  // 搜索成员
  API_MEMBER_LISTMEMBERS: `${apiHost}/member/listMembers`,
  // 分页查询外部人员列表
  API_EXTERNAL_LIST_BY_PAGE: `${apiHost}/external/listByPage`,
  // 账号解绑
  apiAccountUnbind: `${apiHost}/common/account/unbind`,
  /** ******************** org **********************/

  // 人脸录入统计
  API_SCHOOL_STUDENT_FACE_COUNT: `${apiHost}/school/student/face/count`,
  // 班级下成员列表
  API_SCHOOL_USER_CLASS_MEMBERS: `${apiHost}/school/user/class/members`,
  // 查询子部门信息
  API_SCHOOL_USER_DEPT_SUBDEPT: `${apiHost}/school/user/dept/getSubDept`,
  // 人脸录入统计
  API_SCHOOL_USER_FACE_STATISTIC: `${apiHost}/school/user/face/statistic`,
  // 家庭成员列表
  API_SCHOOL_USER_FAMILY_LIST: `${apiHost}/school/user/family/list`,
  // 家长身份录入统计
  API_SCHOOL_USER_COUNT_GUARDIAN: `${apiHost}/school/user/identity/count/guardian`,
  // 职工身份录入统计
  API_SCHOOL_USER_IDENTITY_STAFF: `${apiHost}/school/user/identity/count/staff`,
  // 学生身份录入统计
  API_SCHOOL_USER_IDENTITY_STUDENT: `${apiHost}/school/user/identity/count/student`,
  // 人员信息
  API_SCHOOL_USER_INFO: `${apiHost}/school/user/info`,
  // 创建沙盒
  API_SCHOOL_SANDBOX_ORGUSER_CREATE: `${apiHost}/school/sandbox/orgUser/create`,
  // 家校通讯录沙盒创建
  API_SCHOOL_SANDBOX_USER_CREATE: `${apiHost}/school/user/sandbox/create`,
  // 获取沙盒状态
  API_SANDBOX_STATUS: `${apiHost}/school/user/sandbox/getStatus`,
  // 获取节点信息
  API_SANDBOX_GET_SUBNODES: `${apiHost}/school/user/sandbox/getSubNodes`,

  API_SCHOOL_USER_DEPT_MEMBERS: `${apiHost}/school/user/dept/members`,
  API_SCHOOL_USER_CLASS_STUDENTS: `${apiHost}/school/user/class/students`,
  API_SCHOOL_USER_CLASS_GUARDIAN: `${apiHost}/school/user/class/guardian`,
  // 自定义配置获取
  API_GET_CUSTOM_CONFIG: `${apiHost}/school/config/getCustomConfig`,
  // 按姓名模糊搜索员工
  API_SEARCH_ORG_MEMBER: `${apiHost}/squirrel/common/searchOrgMember`,

  // 通知人员dingIds
  API_SCHOOL_USER_NOTICE_LIST: `${apiHost}/school/user/notice/list`,

  // 消息通知，通过paramId获取url参数
  API_GET_URL_BY_PARAMID: `${apiHost}/school/noticeParam/getParamContent`,

  // 学生详情
  API_SCHOOL_USER_STUDENT_INFO: `${apiHost}/school/user/student/info`,

  // 保存身份信息
  API_SCHOOL_USER_IDENTITY_SAVE: `${apiHost}/school/user/identity/save`,

  // 查询学生信息接口
  API_SCHOOL_GET_STUDENT_LIST: `${apiHost}/school/tag/listStudentInfo`,

  API_GET_IDENTIFY_TYPE: `${apiHost}/school/pc/tag/getCardType`,
  // 自定义通知角色组管理
  API_ROLE_GROUP_LIST: `${apiHost}/school/role/group/list`,

  // 校园监控-手机端扫码登陆
  API_SCHOOL_SECURITY_SCANLOGIN: `${apiHost}/school/security/scanLogin`,
  // 校园监控 - 查询某个机构下的所有摄像头设备
  API_SCHOOL_SECURITY_DEVICE_LIST: `${apiHost}/school/security/query/device/list`,
  // /school/tag/listStudentInfo
  // GET /school/user/student/info

  // 查询机构即将到期或已到期套餐
  API_SCHOOL_MODULE_ORG_EXPIRE_SKU: `${apiHost}/school/module/getOrgExpireSku`,
  // H5查询机构即将到期的亲情通话设备
  API_SCHOOL_MODULE_ORG_EXPIRE_VIDEO_DEVICE: `${apiHost}/school/module/getOrgExpireNewVideoEquity`,

  // 查询该孩子是否是第三方付费机构且是否已经付费
  API_SCHOOL_THIRDPARTY_VERIFY_CALL_PERMISSION: `${apiHost}/school/vip/schoolPay/verify/callPermission`,
  // 权益页：获取当前学年 SKU 列表
  API_RIGHTS_GET_CURRENT_YEAR_SKU_LIST: `${apiHost}/school/vip/getCurrentYearGoodsList`,
  // 权益页：获取商品/支付页链接
  API_ORDER_GET_GOOD_PAGE: `${apiHost}/school/internal/order/getGoodPage`,
  /** 车辆管理 */
  // 获取车辆详情
  API_VEHICLEMANAGE_DETAIL: `${apiHost}/school/barrierGate/userCar/getDetail`,
  // 获取车辆列表
  API_VEHICLEMANAGE_LIST: `${apiHost}/school/barrierGate/userCar/getPageList`,
  // 车辆登记
  API_VEHICLEMANAGE_VEHICLE_REGISTER: `${apiHost}/school/barrierGate/userCar/saveOrUpdate`,
  // 获取车辆分组
  API_VEHICLEMANAGE_VEHICLE_GROUP: `${apiHost}/school/barrierGate/carGroup/getList`,
  // 删除车辆
  API_VEHICLEMANAGE_VEHICLE_DELETE: `${apiHost}/school/barrierGate/userCar/delete`,
  // 获取班级列表
  API_VEHICLEMANAGE_CLASS_LIST: `${apiHost}/school/barrierGate/userCar/getClassList`,
  // 获取家长关系
  API_VEHICLEMANAGE_RELATION_LIST: `${apiHost}/school/tag/guardianRelationInfo`,
  // 发送通知生成短链接
  API_VEHICLEMANAGE_COLLECT_NOTICE: `${apiHost}/school/barrierGate/collect/saveOrUpdate`,
  // 查询短链是否过期
  API_VEHICLEMANAGE_COLLECT_EXPIRED: `${apiHost}/school/barrierGate/collect/getDetail`,
  // 获取车辆列表
  API_VEHICLEMANAGE_LIST2: `${apiHost}/school/barrierGate/userCar/getPageList/v2`,
  // 新增车辆
  API_VEHICLEMANAGE_VEHICLE_SAVE: `${apiHost}/school/barrierGate/userCar/saveOrUpdate/v2`,
  // 获取车辆详情
  API_VEHICLEMANAGE_DETAIL2: `${apiHost}/school/barrierGate/userCar/getDetail/v2`,
  // 用户车辆删除
  API_VEHICLEMANAGE_VEHICLE_DELETE2: `${apiHost}/school/barrierGate/userCar/delete/v2`,
  // 获取全部通行记录
  API_VEHICLEMANAGE_ALLLIST: `${apiHost}/school/barrierGate/recognizeRecord/getAllPageList`,
  // 获取我的通行记录
  API_VEHICLEMANAGE_OWN_LIST: `${apiHost}/school/barrierGate/recognizeRecord/getOwnerPageList`,
  // 获取学生家长本月停车超时次数
  API_VEHICLEMANAGE_TIMECOUNT: `${apiHost}/school/barrierGate/timeout/getTimeoutCount`,
  // 获取该成员车牌列表
  API_VEHICLEMANAGE_GET_USER_LIENCE_NO: `${apiHost}/school/barrierGate/userCar/getLicenseNo`,
  // 获取指定日期通行记录
  API_VEHICLEMANAGE_GET_DAT_RECORDS: `${apiHost}/school/barrierGate/recognizeRecord/getRecognizeRecordByDimDay`,
  // 设置通行规则
  API_VEHICLEMANAGE_SAVE_PASSRULE: `${apiHost}/school/barrierGate/passRule/savePassRule`,
  // 获取通行规则
  API_VEHICLEMANAGE_GET_PASSRULE: `${apiHost}/school/barrierGate/passRule/getPassRule`,
  // 设置超时时间
  API_VEHICLEMANAGE_SAVE_LIMIT_CONFIG: `${apiHost}/school/barrierGate/timeout/saveLimitConfig`,
  // 获取超时时间
  API_VEHICLEMANAGE_GET_LIMIT_CONFIG: `${apiHost}/school/barrierGate/timeout/getLimitConfig`,
  // 保存自动拉黑相关配置
  API_VEHICLEMANAGE_SAVE_BLACK_CONFIG: `${apiHost}/school/barrierGate/blacklist/saveConfig`,
  // 添加黑名单
  API_VEHICLEMANAGE_ADD_BLACK: `${apiHost}/school/barrierGate/blacklist/add`,
  // 删除黑名单
  API_VEHICLEMANAGE_DELETE_BLACK: `${apiHost}/school/barrierGate/blacklist/delete`,
  // 查询黑名单列表
  API_VEHICLEMANAGE_GET_BLACK_LIST: `${apiHost}/school/barrierGate/blacklist/list`,
  // 保存超时通知配置
  API_VEHICLEMANAGE_SAVE_TIME_CONFIG: `${apiHost}/school/barrierGate/timeout/saveTimeoutNoticeConfig`,
  // 保存超时拉黑提醒通知配置
  API_VEHICLEMANAGE_SAVE_BLACK_NOTICE_CONFIG: `${apiHost}/school/barrierGate/timeout/saveBlacklistNoticeConfig`,
  // 获取当前校区超时通知相关配置
  API_VEHICLEMANAGE_GET__CONFIG: `${apiHost}/school/barrierGate/timeout/getNoticeConfig`,
  // 获取当前校区空闲车位数量
  API_VEHICLEMANAGE_GET_LEFT_COUNT: `${apiHost}/school/barrierGate/parkingLot/getFreeParkingSpaceCount`,
  // 获取当前校区车闸版本
  API_VEHICLEMANAGE_GET_API_VERSION: `${apiHost}/school/barrierGate/parkingLot/getBarrierGateVersion`,
  // 车闸首页设置
  API_VEHIDCLE_SETTING: `${apiHost}/school/barrierGate/timeout/getHomePageInfo`,
  // 获取通行记录日历状态
  API_VEHICLE_CALENDAR_STATE: `${apiHost}/school/barrierGate/recognizeRecord/getDimDayStatus`,
  // 名称、班级、超时次数、车牌号集合信息
  API_VEHICLE_CALENDAR_USER_INFO: `${apiHost}/school/barrierGate/userCar/getUserCarInfo`,
  // 获取当前校区车场信息
  API_VEHICLE_GET_PARKING_INFO: `${apiHost}/school/barrierGate/parkingLot/getBarrierGateInfo`,
  // 绑定车场
  API_VEHICLE_BIND_PARKING_INFO: `${apiHost}/school/barrierGate/parkingLot/bindParkingLot`,
  // 解绑车场
  API_VEHICLE_UNBIND_PARKING_INFO: `${apiHost}/school/barrierGate/parkingLot/unbindParkingLot`,
  // 一键抬杆
  API_VEHICLE_CAR_BARRIER_CONTROL: `${apiHost}/school/car/controlBarrierDevice`,
  // 获取车闸设备列表
  API_VEHICLE_CAR_BARRIER_LIST: `${apiHost}/school/car/getThirdCarDeviceList`,
  // 车辆通行申请
  API_VEHICLE_CAR_BARRIER_ACCESS_APPLY: `${apiHost}/school/barrierGate/access/apply`,
  // 车辆通行审批
  API_VEHICLE_CAR_BARRIER_ACCESS_AUDIT: `${apiHost}/school/barrierGate/access/audit`,
  // 车辆通行审批列表
  API_VEHICLE_CAR_BARRIER_ACCESS_LIST: `${apiHost}/school/barrierGate/access/page`,
  /** 车辆管理 */

  /** 校历 */
  // 取消校历的设置
  API_H5_SCHOOL_CALENDAR_CANCEL: `${apiHost}/squirrel/h5/school/calendar/cancel`,
  // 批量获取日历信息
  API_H5_SCHOOL_CALENDAR_QUERY_LIST: `${apiHost}/squirrel/h5/school/calendar/query/list`,
  // 将某一天设置成校历的休息日
  API_H5_SCHOOL_CALENDAR_REST_DAY: `${apiHost}/squirrel/h5/school/calendar/rest/day`,
  // 将某一天设置成校历的工作日
  API_H5_SCHOOL_CALENDAR_WORK_DAY: `${apiHost}/squirrel/h5/school/calendar/work/day`,
  /** 校历 */
  //  班牌绑定自定义模式
  API_CLASSCARD_DEVICE_BIND_CUSTOMMODE: `${apiHost}/squirrel/h5/customMode/bind`,
  //  判断这个机构是否支持班牌自定义模式
  API_CLASSCARD_DEVICE_SUPPORT_CUSTOMMODE: `${apiHost}/squirrel/h5/support/customMode`,

  // H5分页查询机构下亲情通话设备
  API_SQUIRREL_H5_FC_DEVICE: `${apiHost}/squirrel/h5/familyCall/queryFamilyCallDevice`,
  // H5端查询某个亲情通话机是否有亲情通话权限
  API_SQUIRREL_H5_FC_VERIFY_BYSN: `${apiHost}/squirrel/h5/familyCall/verifyCallEquityByDeviceSn`,
  // H5查询新亲情通话套餐设备权益统计数据
  API_SQUIRREL_H5_FC_QUERY_STAT: `${apiHost}/squirrel/h5/familyCall/queryVideoEquityStatistics`,
  // 魔方人脸库来源 GET
  API_GET_FACE_SOURCE: `${apiHost}/commonApi/face/getFaceSource`,

  // 机构是否可在班牌管理开门权限组
  API_SCHOOL_H5_DEVICE_CAN_CONFIG_OPEN_DOOR_PERMISSION_GROUP: `${apiHost}/school/h5/device/canConfigOpenDoorPermissionGroup`,
  // 创建开门权限组
  API_SCHOOL_H5_DEVICE_CREATE_OPEN_DOOR_PERMISSION_GROUP: `${apiHost}/school/h5/device/createOpenDoorPermissionGroup`,
  // 查询权限组下的设备sn
  API_SCHOOL_H5_DEVICE_GET_GROUP_DEVICE_SN: `${apiHost}/school/h5/device/getGroupDeviceIds`,
  // 获取群组范围内部门/人员名称
  API_SCHOOL_H5_DEVICE_GET_RANGE_NAME: `${apiHost}/school/h5/device/getRange`,
  // 机构下是否有门禁设备
  API_SCHOOL_H5_DEVICE_HAS_DEVICE: `${apiHost}/school/h5/device/hasDevice`,
  // 查询开门权限组列表
  API_SCHOOL_H5_DEVICE_LIST_OPEN_DOOR_PERMISSION_GROUP: `${apiHost}/school/h5/device/listOpenDoorPermissionGroup`,
  // 移除开门权限组
  API_SCHOOL_H5_DEVICE_REMOVE_OPEN_DOOR_PERMISSION_GROUP: `${apiHost}/school/h5/device/removeOpenDoorPermissionGroup`,
  // 更新开门权限组
  API_SCHOOL_H5_DEVICE_UPDATE_OPEN_DOOR_PERMISSION_GROUP: `${apiHost}/school/h5/device/updateOpenDoorPermissionGroup`,
  // 根据机构查询标签
  API_SCHOOL_H5_DEVICE_LIST_TAGS: `${apiHost}/school/h5/device/listTags`,

  // 获取出警人列表
  API_BULLY_GET_EXECUTE_PERSON_LIST: `${apiHost}/school/bullyingPrevention/config/getExecutePersonList`,
  // 更新全部出警人
  API_BULLY_UPDATE_EXECUTE_PERSON_LIST: `${apiHost}/school/bullyingPrevention/config/updateExecutePersonList`,

  // 设置未出警通知时间阈值
  API_BULLY_SAVE_UNNITICE_TIME_THRESHOLD: `${apiHost}/school/bullyingPrevention/config/setNotExecuteNoticeTimeThreshold`,

  // 获取未出警通知时间阈值
  API_BULLY_GET_UNNITICE_TIME_THRESHOLD: `${apiHost}/school/bullyingPrevention/config/getNotExecuteNoticeTimeThreshold`,

  // 获取防欺凌设备列表
  API_BULLY_GET_DEVICE_LIST: `${apiHost}/school/bullyingPrevention/device/getList`,

  // 获取防欺凌设备详情
  API_BULLY_GET_DEVICE_INFO: `${apiHost}/school/bullyingPrevention/device/getInfo`,

  // 获取告警信息
  API_BULLY_GET_ALARM_INFO: `${apiHost}/school/bullyingPrevention/alarm/getAlarmInfo`,

  // 确认出警
  API_BULLY_CONFIRM_EXECUTE: `${apiHost}/school/bullyingPrevention/alarm/confirmExecute`,

  // 上传处理结果
  API_BULLY_UPLOAD_HANDLE_RESULT: `${apiHost}/school/bullyingPrevention/alarm/uploadHandleResult`,

  // 获取最近十条告警原因
  API_BULLY_GET_RECENT_ALARM_CAUSE: `${apiHost}/school/bullyingPrevention/alarm/getRecentAlarmCause`,

  // 获取处理中告警列表
  API_BULLY_GET_PROCESS_EVENT_LIST: `${apiHost}/school/bullyingPrevention/alarm/getProcessingList`,

  // 获取已处理告警列表
  API_BULLY_GET_CPMPLETED_EVENT_LIST: `${apiHost}/school/bullyingPrevention/alarm/getCompletedList`,

  // 一键找人
  API_TRACK_RECORD: `${apiHost}/school/h5/security/track/getTrackRecords`,
  /* 校园安全 **/
  // 保存通知间隔
  API_SECURITY_NOTICE_INTERVAL: `${apiHost}/school/h5/security/alert/saveAlertInterval`,
  // 查询间隔
  API_SECURITY_GET_NOTICE_INTERVAL: `${apiHost}/school/h5/security/alert/getAlertInterval`,
  // 查告警列表
  API_SECURITY_ALERT_LIST: `${apiHost}/school/h5/security/alert/getAlertList`,
  API_SECURITY_ALERT_EVENT_LIST: `${apiHost}/school/h5/security/alertEvent/getAlertProcessList`,

  API_SECURITY_MY_CLASS_ALERT_EVENT_LIST: `${apiHost}/school/h5/security/alertEvent/getMyClassAlertProcessList`,

  API_SECURITY_ALERT_EVENT_DETAIL: `${apiHost}/school/h5/security/alertEvent/getAlertProcessDetail`,
  // 告警详情
  API_SECURITY_ALERT_DETAILS: `${apiHost}/school/h5/security/alertHandled/getAlertDetail`,
  API_SECURITY_ALERT_CONFIRM_EXRCUTE: `${apiHost}/school/h5/security/alertHandled/confirmExecute`,
  API_SECURITY_ALERT_UPLOAD_RESULT: `${apiHost}/school/h5/security/alertHandled/uploadHandledResult`,
  API_SECURITY_ALERT_CAUSES: `${apiHost}/school/h5/security/alertHandled/getRecentAlertCause`,
  // 防欺凌设备
  API_SCHOOL_SECURITY_GET_BULLY_DEVICE: `${apiHost}/school/security/pc/queryBullyingDevice`,
  // 查天告警类型统计-维度=告警类型
  API_SECURITY_ALERT_TYPE: `${apiHost}/school/h5/security/alert/getAlertStatisticsByAlertType`,
  // 查天告警类型统计-维度=人员
  API_SECURITY_ALERT_MEMBER_INFO_BYDAY: `${apiHost}/school/h5/security/alert/getAlertStatisticsByMember`,
  // 查某人时间范围内告警统计-维度:告警类型
  API_SECURITY_ALERT_MEMBER_INFO: `${apiHost}/school/h5/security/alert/getMemberAlertStatistics`,
  API_SECURITY_UPDATE_NOTICE_ENABLE: `${apiHost}/school/notice/updateNoticeGroupEnable`,
  API_SECURITY_NOTICE_DEVICE_LIST: `${apiHost}/school/h5/security/alert/getDeviceList`,
  API_SECURITY_NOTICE_AlERT_INFO: `${apiHost}/school/h5/security/alert/getAlertInfo`,
  API_SECURITY_NOTICE_AlERT_DETAIL: `${apiHost}/school/h5/security/alert/getAlertDetail`,

  // 校园安全-数据总览

  // 报警处理数量统计
  API_SCHOOL_SECURITY_ALERT_PROCESS_COUNT_STATISTICS: `${apiHost}/school/h5/security/statistics/getAlertProcessCountStatistics`,

  // 报警类型数量统计
  API_SCHOOL_SECURITY_ALERT_TYPE_COUNT_STATISTICS: `${apiHost}/school/h5/security/statistics/getAlertTypeCountStatistics`,

  // 报警类型数量统计-我的班级
  API_SCHOOL_SECURITY_ALERT_TYPE_COUNT_STATISTICS_MY_CLASS: `${apiHost}/school/h5/security/statistics/getMyClassAlertTypeCountStatistics`,

  // 班级-右侧上边列表-该班级的报警记录列表
  API_SCHOOL_SECURITY_CLASS_ALARM_PAGE: `${apiHost}/school/h5/security/statistics/getClassAlarmPage`,

  // 班级-右侧中-柱状图
  API_SCHOOL_SECURITY_GET_CLASS_HISTOGRAM: `${apiHost}/school/h5/security/statistics/getClassHistogram`,

  // 班级-右侧下-折线图
  API_SCHOOL_SECURITY_GET_CLASS_LINE_CHART: `${apiHost}/school/h5/security/statistics/getClassLineChart`,

  // 班级-右侧中-该班级的饼状图
  API_SCHOOL_SECURITY_GET_CLASS_PIE_CHART: `${apiHost}/school/h5/security/statistics/getClassPieChart`,

  // 班级-左侧列表-班级统计信息
  API_SCHOOL_SECURITY_CLASS_STATISTICS_LIST: `${apiHost}/school/h5/security/statistics/getClassStatisticsList`,

  // 获取设备列表
  API_SCHOOL_SECURITY_STATISTICS_DEVICE_LIST: `${apiHost}/school/h5/security/statistics/getDeviceList`,

  // 获取设备统计信息
  API_SCHOOL_SECURITY_GET_DEVICE_STATISTICS: `${apiHost}/school/h5/security/statistics/getDeviceStatistics`,

  // 年级-右侧上边列表-该年级的报警记录列表
  API_SCHOOL_SECURITY_GET_GRADE_ALARM_PAGE: `${apiHost}/school/h5/security/statistics/getGradeAlarmPage`,

  // 年级-右侧中-柱状图
  API_SCHOOL_SECURITY_GRADE_HISTOGRAM: `${apiHost}/school/h5/security/statistics/getGradeHistogram`,

  // 年级-右侧下-折线图
  API_SCHOOL_SECURITY_GET_GRADE_LINE_CHART: `${apiHost}/school/h5/security/statistics/getGradeLineChart`,

  // 年级-右侧中-该年级的饼状图
  API_SCHOOL_SECURITY_GET_GRADE_PIE_CHART: `${apiHost}/school/h5/security/statistics/getGradePieChart`,

  // 年级-左侧列表-年级统计信息
  API_SCHOOL_SECURITY_GRADE_STATISTICS_LIST: `${apiHost}/school/h5/security/statistics/getGradeStatisticsList`,

  // 地区-右侧上边列表-该地区的报警记录列表
  API_SCHOOL_SECURITY_GET_REGION_ALARM_PAGE: `${apiHost}/school/h5/security/statistics/getRegionAlarmPage`,

  // 地区-右侧下-折线图
  API_SCHOOL_SECURITY_GET_REGION_LINE_CHART: `${apiHost}/school/h5/security/statistics/getRegionLineChart`,

  // 地区-右侧中-该地区的饼状图
  API_SCHOOL_SECURITY_GET_REGION_PIE_CHART: `${apiHost}/school/h5/security/statistics/getRegionPieChart`,

  // 地区-左侧列表-地区统计信息
  API_SCHOOL_SECURITY_GET_REGION_STATISTICS_LIST: `${apiHost}/school/h5/security/statistics/getRegionStatisticsList`,

  // 学生-右侧上边列表-该学生的报警记录列表
  API_SCHOOL_SECURITY_GET_STUDENT_ALARM_PAGE: `${apiHost}/school/h5/security/statistics/getStudentAlarmPage`,

  // 学生-右侧下-折线图
  API_SCHOOL_SECURITY_GET_STUDENT_LINE_CHART: `${apiHost}/school/h5/security/statistics/getStudentLineChart`,

  // 学生-右侧中-该学生的饼状图
  API_SCHOOL_SECURITY_GET_STUDENT_PIE_CHART: `${apiHost}/school/h5/security/statistics/getStudentPieChart`,

  // 学生-左侧列表-学生统计信息
  API_SCHOOL_SECURITY_GET_STUDENT_STATISTICS_LIST: `${apiHost}/school/h5/security/statistics/getStudentStatisticsList`,

  // 筛选项 - 告警列表
  API_SCHOOL_SECURITY_GET_ALERT_TYPES: `${apiHost}/school/h5/security/statistics/getAlertTypeList`,
  // 批量休眠、唤醒
  API_BETCH_UPDATE_SLEEP: `${apiHost}/squirrel/h5/device/batchUpdateDeviceSleepWakeUp`,
  // 是否展示休眠入口
  API_COMMON_IS_GRAYORG: `${apiHost}/squirrel/common/isGrayOrg`,
  // 查询机构灰度功能列表
  API_GET_ORG_GRAY_FUNCTION: `${apiHost}/school/gray/getOrgGrayFunctionList`,
  // 根据设备SN 获取设备Id
  API_GET_DEVICEIO_BY_SN: `${apiHost}/school/h5/device/getDeviceIdBySn`,
  // 班级的课堂行为统计
  API_BEHAVIOR_STAT: `${apiHost}/school/h5/cba/behaviorStat`,
  // 分页查询课堂行为列表
  API_BEHAVIOR_LIST: `${apiHost}/school/h5/cba/pageBehavior`,
  // 导出课堂行为统计报表（通过工作通知发送给操作人员）
  API_BEHAVIOR_EXPORT: `${apiHost}/school/h5/cba/exportBehaviorStat`,

  // 创建轨迹记录
  API_SECURITY_TRACK_CREATE_QUERY_TRACK_TASK: `${apiHost}/school/h5/security/track/createQueryTrackTask`,

  // 按时间查某人的轨迹记录
  API_SECURITY_TRACK_GET_TRACK_PROCESS: `${apiHost}/school/h5/security/track/getTrackProcess`,

  // 绑定校区/告警类型/区域
  API_BIND_ALERT_INFO_H5: `${apiHost}/school/disciplinary/bindAlertInfoH5`,

  // 获取告警类型列表
  API_QUERY_DISCRIMINAL_TYPE_LIST_H5: `${apiHost}/school/disciplinary/queryDisciplinaryTypeListH5`,

  // 获取告警区域列表
  API_QUERY_DISCRIMINAL_AREA_LIST_H5: `${apiHost}/school/disciplinary/queryDisciplinaryAreaListH5`,

  // h5-我的班级-右侧上边列表-该学生的报警记录列表
  API_SECURITY_GET_MY_CLASS_STUDENT_ALARM_PAGE: `${apiHost}/school/h5/security/statistics/getMyClassStudentAlarmPage`,

  // h5-我的班级-右侧下-折线图
  API_SECURITY_GET_MyClassStudentLineChart: `${apiHost}/school/h5/security/statistics/getMyClassStudentLineChart`,

  // h5-我的班级-右侧中-该学生的饼状图
  API_SECURITY_GET_MyClassStudentPieChart: `${apiHost}/school/h5/security/statistics/getMyClassStudentPieChart`,

  // h5-我的班级-左侧列表-学生统计信息
  API_SECURITY_GET_MyClassStudentStatisticsList: `${apiHost}/school/h5/security/statistics/getMyClassStudentStatisticsList`,

  // h5-钉盘授权
  API_SECURITY_uploadFileToDingPermission: `${apiHost}/school/h5/security/alertEvent/uploadFileToDingPermission`,

  // h5-我的班级-查看-告警处理-已完成列表
  API_SECURITY_getMyClassCompletedAlertList: `${apiHost}/school/pc/security/alertEvent/getMyClassCompletedAlertList`,

  /* ---------------- 进出校统计 start ---------------- */
  // 批量添加不参与统计的学生
  API_ATSCHOO_BARCH_ADD_EXCLUDE_STUDENT: `${apiHost}/school/h5/access/student/batchAddExclusiveStudent`,
  // 批量删除不参与统计的学生
  API_ATSCHOO_BARCH_DELETE_EXCLUDE_STUDENT: `${apiHost}/school/h5/access/student/batchDeleteExclusiveStudent`,
  // 班级学生在校情况实时统计
  API_ATSCHOOL_GET_CLASS_STAT: `${apiHost}/school/h5/access/student/getClassStatList`,
  // 根据状态查询班级学生在校情况实时统计
  API_ATSCHOOL_GET_CLASS_STAT_BY: `${apiHost}/school/h5/access/student/getClassStatListByStatus`,
  // 查询班级学生状态列表
  API_ATSCHOOL_GET_CLASS_STUDENT: `${apiHost}/school/h5/access/student/getClassStudentList`,
  // 部门学生在校情况实时统计（根据角色统计）
  API_ATSCHOOL_GET_DEPT_STAT: `${apiHost}/school/h5/access/student/getDeptStat`,
  // 分页查询不参与统计的学生
  API_ATSCHOO_EXCLUDE_STUDENT: `${apiHost}/school/h5/access/student/getPageExclusiveStudent`,
  // 查询学生进出校记录列表
  API_ATSCHOO_GET_STUDENT_RECORDS: `${apiHost}/school/h5/access/student/getStudentAccessRecords`,
  // 查询学生每日在校状态列表 1：正常 0：异常 -1：未知
  API_ATSCHOO_GET_STUDENT_DETAILS: `${apiHost}/school/h5/access/student/getStudentDailyStatusList`,
  // 修改进出校日历状态
  API_ATSCHOO_MODIFY_STUDENT_DAILY: `${apiHost}/school/h5/access/student/modifyDaily`,
  // 搜索进出校学生
  API_ATSCHOO_SEARCH_STUDENT: `${apiHost}/school/h5/access/student/searchStudent`,
  // 搜索进出校组
  API_ATSCHOO_SEARCH_STUDENT_GROUP: `${apiHost}/school/access/group/listByMember`,
  // 获取进出校日历状态
  API_ATSCHOOL_GET_TASK_ID: `${apiHost}/school/h5/access/student/getTaskInfo`,
  // 修改进出校日历状态V2
  API_ATSCHOOL_MODIFY_DAILY_V2: `${apiHost}/school/h5/access/student/modifyDailyV2`,
  /* ---------------- 设备进出校统计 end ---------------- */

  /* ---------------- 设备进出校start ---------------- */
  API_GET_ACCESS_DEVICE_LIST: `${apiHost}/school/access/device/educationList`,
  API_GET_CUSTOM_H5_CONFIG: `${backStageTowerHost}/custom/h5/config`,
  // POST 添加进出校设备
  API_OPENDOOR_DEVICE_ADD: `${apiHost}/school/access/device/add`,
  // GET删除进出校设备
  API_OPENDOOR_DEVICE_DELETE: `${apiHost}/school/access/device/delete`,
  // GET查询进出校设备
  API_OPENDOOR_DEVICE_LIST: `${apiHost}/school/access/device/list`,
  // 删除进出校权限组
  API_OPENDOOR_GROUP_DELETE: `${apiHost}/school/access/group/delete`,
  // GET进出校权限组详情
  API_OPENDOOR_GROUP_DETAIL: `${apiHost}/school/access/group/detail`,
  // POST编辑进出校组
  API_OPENDOOR_GROUP_EDIT: `${apiHost}/school/access/group/edit`,
  // GET进出校权限组列表
  API_OPENDOOR_GROUP_LIST: `${apiHost}/school/access/group/list`,
  // POST新增进出校权限组
  API_OPENDOOR_GROUP_SAVE: `${apiHost}/school/access/group/save`,
  API_FACEDOOR_GROUP_COUNT: `${apiHost}/school/access/attenceGroup/count`,
  // 自定义配置获取配置--机构维度
  API_GET_CUSTOM_CONFIG_BY_ORG: `${apiHost}/school/config/getCustomConfig/V2`,
  // 进出校-家长通知
  API_OPENDOOR_GROUP_NOTICE: `${apiHost}/school/h5/access/student/getNoticeDetail`,
  /* ---------------- 设备进出校end ---------------- */
  /* ---------------- 其它 start ---------------- */
  // 查询用户授权信息
  API_OTHER_GET_AUTH_INFO: `${apiHost}/school/other/getAuthInfo`,
  // 保存授权信息
  API_OTHER_SET_AUTH_INFO: `${apiHost}/school/other/setAuthInfo`,
  // 模拟用户信息
  API_OTHER_MOCK_USERINFO: `${apiHost}/school/other/mockUserInfo`,
  /* ---------------- 其它 end ---------------- */
  /* ---------------- 就餐 start ---------------- */
  // 批量添加不上传到收费系统的学生
  API_STUDENT_MEAL_BATCH_ADD_EXCLUSIVE_STUDENT: `${apiHost}/squirrel/h5/studentMeal/batchAddExclusiveStudent`,
  // 导出学生用餐记录为Excel（通过工作通知发送给操作人员）
  API_STUDENT_MEAL_EXPORT_RECORD: `${apiHost}/squirrel/h5/studentMeal/exportMealRecordExcel`,
  // 查询该校区下所有班级就餐统计
  API_STUDENT_MEAL_GET_ALL_STATISTICS: `${apiHost}/squirrel/h5/studentMeal/getAllClassMealStatistics`,
  // 根据日期查询学生就餐状态 -1当天无数据 0当天有数据且没有未吃饭记录 1当天有数据且存在未吃饭记录
  API_STUDENT_MEAL_GET_DAY_STATUS: `${apiHost}/squirrel/h5/studentMeal/getDimDayStatus`,
  // 分页查询不上传到收费系统的学生
  API_STUDENT_MEAL_GET_EXCLUSIVE_STUDENT: `${apiHost}/squirrel/h5/studentMeal/getExclusiveStudentList`,
  // 根据状态查询学生列表
  API_STUDENT_MEAL_GET_STUDENT_LIST_BY_STATUS: `${apiHost}/squirrel/h5/studentMeal/getStudentListByMealStatus`,
  // 根据日期查询学生就餐记录
  API_STUDENT_MEAL_GET_STUDENT_RECORD: `${apiHost}/squirrel/h5/studentMeal/getStudentMealRecord`,
  // 查询学生用餐设置
  API_STUDENT_MEAL_GET_STUDENT_SETTING: `${apiHost}/squirrel/h5/studentMeal/getStudentMealSetting`,
  // 保存学生用餐设置
  API_STUDENT_MEAL_SAVE_STUDENT_SETTING: `${apiHost}/squirrel/h5/studentMeal/saveStudentMealSetting`,
  /* ---------------- 就餐 end ---------------- */
  // 获取机构标签信息
  API_TAG_GET_TAGS: `${apiHost}/school/tag/getTags`,
  // 查询行政班签到详情
  API_COURSE_CLASS_SIGN_CLASS_DETAIL: `${apiHost}/squirrel/h5/course/class/sign/class/detail`,
  // 查询行政班签到情况 - 查询班级列表
  API_COURSE_CLASS_SIGN_CLASS_LIST: `${apiHost}/squirrel/h5/course/class/sign/class/list`,
  // 导出课表为Excel
  API_COURSE_CLASS_SIGN_EXPORT_CLASS_SCHEDULE: `${apiHost}/squirrel/h5/course/class/sign/exportClassSchedule`,
  /* ---------------- 支付 start ---------------- */
  // 查询个人付费详情
  API_PAYMENT_GET_SKU_CONFIG: `${apiHost}/school/v3/h5/sku/getOrgTrialSkuConfig`,
  // 查询机构套餐列表
  API_PAYMENT_GET_ORGSKU: `${apiHost}/school/v3/h5/sku/getOrgSku`,
  // 钉钉付费接口
  API_PAYMENT_SAVE_ORDER: `${apiHost}/school/v3/h5/sku/order/alipay/saveOrder`,
  // 查订单支付状态
  API_PAYMENT_GET_ORDER_SRTATUS: `${apiHost}/school/v3/h5/sku/order/getOrderStatus`,
  // 查学生历史订单
  API_PAYMENT_GET_ORDER_LIST: `${apiHost}/school/v3/h5/sku/order/getOrderList`,
  // 调用支付宝支付
  API_PAYMENT_ALIPAY_PAY: `${apiHost}/payment/alipay/pay`,
  // 支付宝订单同步通知
  API_PAYMENT_ALIPAY_PAY_NOTICE: `${apiHost}/school/v3/h5/sku/order/alipay/syncNotice`,
  // 查询是否是亲情通话付费机构
  API_PAYMENT_THIRD_PAY_ORG: `${apiHost}/school/vip/schoolPay/verify/thirdPayOrg/callPermission`

  /* ---------------- 支付 end ---------------- */
}
